import { Component, OnInit, ViewChild, ElementRef, OnChanges, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { find, get, pull, truncate } from 'lodash';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { IomService } from 'src/app/services/iom.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService } from 'src/app/services/message.service';
import { importType } from '@angular/compiler/src/output/output_ast';
import { Category } from 'src/app/models/AutomationOpportunities';
import { SessionService } from 'src/app/services/session.service';
import { EllipsisModule } from 'ngx-ellipsis';
import { AppConfigService } from 'src/app/services/app-config.service';
declare var bootbox: any;
declare var $: any;
@Component({
  selector: 'app-automation-opportunities',
  templateUrl: './automation-opportunities.component.html',
  styleUrls: ['./automation-opportunities.component.css']
})
export class AutomationOpportunitiesComponent implements OnChanges {
  isLoadNewCategory = false;
  enableBox = false;
  blob: Blob;
  @ViewChild('tagInput') tagInputRef: ElementRef;
  tags: string[] = [];
  form1: FormGroup;
  VersionId: string;
  DDName: string;
  TicketCatagories: any;
  Language: any;
  envVar: any;
  AllCategoryNames: any;
  ClassificationTypeId: number;
  Domain: string;
  ExitCondition: number;
  ExitCondition_Old: number;
  IsFDSReadonly: boolean;
  IsProcessEnabled: boolean;
  IsProcessed: any;
  IsStopWordProcess: number;
  ProcessLevel: number;
  ProposalId: number;
  OpportunityBy: string;
  NoofCluster: number;
  NoofCluster_Old: number;
  IsDisableEditCatgoryandSubcategory: number;
  IsKmeans: boolean;
  isCatOptionsEnabled: boolean = true;
  isSubcatOptionsEnabled: boolean = true;
  CategoryObj: Category = new Category();
  SplitObj: Category = new Category();
  MergeObj: Category = new Category();
  SelectedObject: { isLeft: boolean, keyword: string, isInclude: boolean };
  mergeCount: number = 0;
  MergeCatBtnText: string = "Merge";
  MergeSubcatBtnText: string = "Merge";
  isMergeEnabled: boolean = false;
  ClassificationType: string;
  userType: number;
  EditCluster: boolean;
  EditExitcondition: boolean;
  categoryNameEditOnly: boolean = false;
  subCategoryNameEditOnly: boolean = false;
  disableStopKeywords: boolean = false;
  disableNewCategory: boolean = false;
  isClusterChanged: boolean;
  isExitChanged: boolean;
  NoData: boolean;
  NoSubCategory : boolean;
  envData: any;
  userName: string;
  IsProcessEnabled_old: boolean;
  isClusterChanged_categoryLevel: boolean;
  isExitChanged_categoryLevel: boolean;
  StopKeywords: any;
  stopKeywords_Array: string[] = [];
  disableDelete: boolean = true;
  disableSelectAll: boolean = true;
  SelectAllStatus: boolean;
  @Input() magicNumber: any;
  @Input() activefilter = false;
  @Input() DQTFilterDetails: any;
  @Input() IsFilterModified: boolean;
  tempAddTags: string[] = [];
  tempRemoveTags: string[] = [];
  disableIgnoreModal: boolean = false;
  indexOf = (arr, q) => arr.findIndex(item => q.toLowerCase() === item.toLowerCase());
  include_enable: boolean = false;
  mergedisable: boolean = false;
  reenabled: boolean = true;
  EnableSave: boolean = false;
  IsLemmaEnabled: boolean=false;
  IsLemmaChecked: boolean=false;
  LemmaDisableLR: boolean=false;
  disLemma: boolean=false;
  Language_Recat: any;
  selectedLangAll: boolean;
  constructor(private appConfigService: AppConfigService, private messageService: MessageService, private activatedRoute: ActivatedRoute, private router: Router, private sessionService: SessionService, private fb: FormBuilder, private spinner: NgxSpinnerService, public iomservice: IomService) {
    // this.activatedRoute.queryParams.subscribe(params => {
    //   this.VersionId = +params['VersionId']; // + is for converting the string to number
    //   this.DDName = params['DDName'];
    // });
    this.envVar = this.appConfigService.getEnvironment();
    this.userName = this.sessionService.getUserName();
    this.VersionId = (localStorage.getItem("VersionIdMongo"));
    if (this.VersionId != "") {
      //this.iomservice.GetFlowDetailsbyVersionId(this.VersionId, this.userName);
    }
  }
  ngOnChanges(): void {
    var LemmaEnable = this.sessionService.getSessionStorageItem('IsLemmaEnabled');
    this.IsLemmaEnabled = JSON.parse(LemmaEnable);
    
    $(document).ready(function () {
      $(window).scroll(function () {
        if ($(this).scrollTop() >= $('.myw-topbar').offset().top)
          $('body').addClass('myw-sticky');
        else
          $('body').removeClass('myw-sticky');
      }).trigger('scroll');
    });
    this.spinner.show();
    this.VersionId = (localStorage.getItem("VersionIdMongo"));
    this.envData = this.appConfigService.getEnvironment();
    this.userType = parseInt(this.sessionService.getSessionStorageItem('userType'));
    //Load Category and Subcategory Data
    this.GetCategoryandSubcategoryData(this.VersionId,true);
    this.form1 = this.fb.group({
      tag: [undefined],
    });
    
  }
  GetCategoryandSubcategoryData(VersionId, recatflag:boolean) {
    let that = this;
    this.tags = [];
    this.disableIgnoreModal = false;
    this.disableNewCategory = false;
    this.categoryNameEditOnly = false;
    this.subCategoryNameEditOnly = false;
    this.disableStopKeywords = false;
    this.disableNewCategory = false;
    this.disableDelete = true;
    this.disableSelectAll = true;
    this.isCatOptionsEnabled = true;
    this.isSubcatOptionsEnabled = true;
    this.mergeCount = 0;
    this.MergeCatBtnText = "Merge";
    this.MergeSubcatBtnText = "Merge";
    this.isMergeEnabled = false;
    this.isLoadNewCategory = false;
    this.enableBox = false;
    if(this.DQTFilterDetails != null && this.DQTFilterDetails.length > 0){
      this.activefilter = true;
    }
    else{
      this.activefilter = false;
    }

    var SelectedLanguage = this.sessionService.getSessionStorageItem('SelectedDDLanguage');  
    var SelectedLanguageEdit = this.sessionService.getSessionStorageItem('SelectedLanguage');
  
    if(SelectedLanguage==null || SelectedLanguage==undefined || SelectedLanguage=='' || SelectedLanguage=='null')
    {
      SelectedLanguage='All';
    }
    else if(SelectedLanguageEdit!=null && SelectedLanguageEdit!=undefined)
    {
      if(!SelectedLanguageEdit.includes('|'))
      {
        SelectedLanguage='All';
      }
    }

    this.iomservice.GetCategoryandSubcategoryData(VersionId,SelectedLanguage, this.DQTFilterDetails,this.IsFilterModified).subscribe((data: any) => {
      this.spinner.hide();
      if (data.Result) {
        this.TicketCatagories = data.Result.TicketCatagories;
        if (data.Result.TicketCatagories?.length > 0) {
          this.NoData = false;
        }
        else {
          this.NoData = true;
        }
        this.AllCategoryNames = data.Result.AllCategoryNames;
        this.Language = this.envVar.EnableLanguage ?  data.Result.Language : 'English';   
        this.Language_Recat = data.Result.Language_Recat;     
        this.ClassificationTypeId = data.Result.ClassificationTypeId;
        this.ClassificationType = this.GetClassificationTypeName(this.ClassificationTypeId);
        this.Domain = data.Result.Domain;
        this.ExitCondition = data.Result.ExitCondition;
        this.ExitCondition_Old = this.ExitCondition;
        this.IsFDSReadonly = data.Result.IsFDSReadonly;
        this.IsProcessEnabled = data.Result.IsProcessEnabled;
        this.IsProcessEnabled_old = this.IsProcessEnabled;
        var LemmaChecked = this.sessionService.getSessionStorageItem('IsLemmaChecked');
        if(LemmaChecked=='1')
        {
          this.IsProcessEnabled = true;
        }
        this.IsStopWordProcess = data.Result.IsStopWordProcess;
        this.ProcessLevel = data.Result.ProcessLevel;
        this.ProposalId = data.Result.ProposalId;
        this.OpportunityBy = data.Result.OpportunityBy;
        this.NoofCluster = data.Result.NoofCluster;
        this.NoofCluster_Old = this.NoofCluster;
        this.IsDisableEditCatgoryandSubcategory = data.Result.IsDisableEditCatgoryandSubcategory;
        this.IsKmeans = data.Result.IsKmeans;
        this.StopKeywords = data.Result.StopWords != null ? data.Result.StopWords.trim() : data.Result.StopWords;
        this.stopKeywords_Array = this.StopKeywords?.split(',');
        if (this.stopKeywords_Array && this.stopKeywords_Array.length > 0) {
          this.stopKeywords_Array = this.unique(this.stopKeywords_Array);
          for (var i = 0; i < this.stopKeywords_Array.length; i++) {
            if(this.stopKeywords_Array[i].trim()!='' && this.stopKeywords_Array[i].trim() !=null &&  this.stopKeywords_Array[i].trim()!=' ')
            {
            this.addTag(this.stopKeywords_Array[i].trim(), false, false);
            }
          }
        }

        var SelectedLanguageEdit = this.sessionService.getSessionStorageItem('SelectedLanguage');
        if(SelectedLanguageEdit.toString().includes('Chinese')){
          this.disLemma = true;
        }
        else{
          this.disLemma = false;
        }
        if (data.Result.ProposalId != 0) {
          if (this.userType == 1) {
            this.sessionService.setSessionStorageItem('selectedProposalId', data.Result.ProposalId);
          }
        }
        if (data.Result.IsDisableEditCatgoryandSubcategory == 1 || this.ClassificationTypeId == 3) {
          this.IsFDSReadonly = true;
          this.IsProcessEnabled = false;
          //this.IsKmeans = false;
        }
        else {
          this.IsFDSReadonly = false;
        }
        if (!this.IsEmpty(data.Result.DeepDiveName)) {
          this.DDName = data.Result.DeepDiveName.trim();
        }
        this.ShowOptions();
      }
      var SelectedLanguageEdit = this.sessionService.getSessionStorageItem('SelectedLanguage');
      if(SelectedLanguageEdit!=null && SelectedLanguageEdit!=undefined)
      {
        if(recatflag){
          if(SelectedLanguageEdit.includes('|'))
            {          
            if(SelectedLanguage=='All')
            {
              this.DisableEditLanguageAll(true);
              this.selectedLangAll = true;
            }                
            else if(this.Language_Recat!=null && this.Language_Recat!=undefined && this.Language_Recat!='BsonNull' && this.Language_Recat!='All' && this.Language_Recat!=SelectedLanguage )
            {
              this.DisableEditLanguageAll(true);
            }
            else{
              this.IsProcessEnabled = false;
              this.selectedLangAll = false;
              if(this.IsKmeans){
                this.EditCluster = true;
                this.EditExitcondition = true;
              }
            }
          }
        }                
      }
      this.expendSubCategory(); // when redirect from category header click
      var IsACUser = this.sessionService.getSessionStorageItem('IsACUser');
      if(IsACUser.toString() == "1")
      {
        this.LemmaDisableLR=true;
      }
      //TODO: Take the status of the deliveryconstructUId for the versionid. If it is 'closed', disable edit.
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        bootbox.alert("Timeout. Please Refresh and Try again");
      });
  }
  ShowOptions() {
    if (this.IsFDSReadonly) {
      //this.IsKmeans = false;
      this.DisableEdit();
      this.isCatOptionsEnabled = false;
      this.isSubcatOptionsEnabled = false;
    }
    else {
      // IO - ICI Classification
      if (this.ClassificationTypeId == 3) {
        this.IsKmeans = false;
        this.DisableEdit();
      }

      // // Kmeans Classification
      // else if (this.ClassificationTypeId == 2) {
      //   this.IsKmeans = true;
      //   this.categoryNameEdit = true;
      //   this.subCategoryNameEdit = true;
      // }

      // User defined and SAP Classification [Normal flow]
      else {
        if (!this.IsEmpty(this.OpportunityBy)) {
          this.ProcessLevel = 1;
        }
        // Disable Category edit. Allow Subcategory Edit
        if (this.ProcessLevel == 1) {
          this.disableNewCategory = true;
          this.isCatOptionsEnabled = true;
          this.isSubcatOptionsEnabled = true;
          this.categoryNameEditOnly = true;
          this.subCategoryNameEditOnly = false;
          // Disable stop keywords
          this.disableStopKeywords = true;
          // if (!this.IsEmpty(this.OpportunityBy)) {
          //   // Disable stop keywords
          //   this.disableStopKeywords = true;
          // }
        }
        // Disable Subcategory edit. Allow Category Edit
        else if (this.ProcessLevel == 2) {
          this.isCatOptionsEnabled = true;
          this.isSubcatOptionsEnabled = true;
          this.categoryNameEditOnly = false;
          if (this.ClassificationTypeId == 2)
            this.subCategoryNameEditOnly = false;
          else
            this.subCategoryNameEditOnly = true;
        }
        // Fresh deepdive
        else if (this.ProcessLevel == 3) {
          this.isCatOptionsEnabled = true;
          this.isSubcatOptionsEnabled = true;
          this.categoryNameEditOnly = false;
          this.subCategoryNameEditOnly = false;
        }
        // Stop keywords flow. Disable Subcategory edit. Allow Category Edit
        else {
          this.isCatOptionsEnabled = true;
          this.isSubcatOptionsEnabled = true;
          this.categoryNameEditOnly = false;
          if (this.ClassificationTypeId == 2)
            this.subCategoryNameEditOnly = false;
          else
            this.subCategoryNameEditOnly = true;
        }
      }
      if (this.IsKmeans) {
        this.disableNewCategory = true;
      }
    }
  }
  DisableEdit() {
    this.isCatOptionsEnabled = true;
    this.isSubcatOptionsEnabled = true;
    this.categoryNameEditOnly = true;
    this.subCategoryNameEditOnly = true;
    this.IsProcessEnabled = false;
    this.EditCluster = false;
    this.EditExitcondition = false;
    this.disableStopKeywords = true;
    this.disableNewCategory = true;
    this.IsFDSReadonly = true;
    this.disableIgnoreModal = true;
  }
  GetClassificationTypeName(classificationTypeId) {
    switch (classificationTypeId) {
      case 1:
        this.LemmaDisableLR=false;
        return "User Defined (N-gram)";
        break;
      case 2:
        this.LemmaDisableLR=false;
        return "Auto Categorization (K-means)";
        break;
      case 3:
        this.LemmaDisableLR=true;
        this.IsLemmaEnabled = false;
        return "Logistic Regression";
        break;
      case 4:
        this.LemmaDisableLR=false;
        return "SAP Classification";
        break;
      default:
        break;
    }
  }
  loadNewCategory() {
    this.isLoadNewCategory = true;
    this.CategoryObj = new Category();
    this.CategoryObj.excludedBtnName = "Add";
    this.CategoryObj.includedBtnName = "Add";
    this.CategoryObj.IncludedKeywords = [];
    this.CategoryObj.ExcludedKeywords = [];
  }
  loadCategoryTable() {
    this.isLoadNewCategory = false;
  }
  //tags
  focusTagInput(): void {
    this.tagInputRef.nativeElement.focus();
  }
  keywordsAdd(event: any) {
    const inputValue: string = this.form1.controls.tag.value;    
    var SelectedLanguage = this.sessionService.getSessionStorageItem('SelectedDDLanguage');
    if(SelectedLanguage==null || SelectedLanguage==undefined || SelectedLanguage=='' || SelectedLanguage=='null')
    {
    SelectedLanguage='All';
    }
    if ((/^[a-zA-Z0-9-/_&\s]*$/.test(inputValue)) == false && (this.envVar.EnableLanguage ?  this.Language : 'English') == 'English') { //((/[0-9]/.test(catName)) == true || 
      bootbox.alert("Keyword must be a single word and should contain alphabets only");
      return false;
    }
    if (this.IsEmpty(inputValue)) {
      bootbox.alert("Please enter ignore keywords");
    }
   else {
    if(this.IsLemmaEnabled)
    {
      let that = this;
      bootbox.dialog({
        message: 'The entered text will be added in the lemmatized form',
        buttons: {
          sucess: {
            label: 'Yes',
            className: 'btn-primary',
            callback: function () {
                that.spinner.show();                
                that.iomservice.GetLemmaKeywords(that.VersionId,'','', inputValue,SelectedLanguage).subscribe((data: any) => {
                that.spinner.hide();
                  if (data.response.Result == "Success") {
                    var LemmaString = data.response.LemmaResponse.StopKeyWords_Lemma;
                    that.addTag(LemmaString, true, true);
                    that.form1.controls.tag.setValue('');
                  }
                  else {
                    bootbox.alert("Timeout. Please Refresh and Try again");
                  }
                },
                  (err: HttpErrorResponse) => {
                    that.spinner.hide();
                    bootbox.alert("Timeout. Please Refresh and Try again");
                  });
            }
          },
          cancel: {
            label: 'No',
            className: 'btn-secondary',
            callback: function () {
                that.addTag(inputValue, true, true);
                that.form1.controls.tag.setValue('');
            }
          }
        },
        onEscape: function () {
          //on escape
      }
      });
    }
    else{
    this.addTag(inputValue, true, true);
    this.form1.controls.tag.setValue('');
    }
   }

    //}
  }
  SelectAllKeywords() {
    if (this.SelectAllStatus) {
      $('.tag-item').css('background', 'Highlight');
      this.disableDelete = false;
    }
    else {
      $('.tag-item').css('background', 'none');
      this.disableDelete = true;
    }
  }
  DeleteAllKeywords() {
    this.tempRemoveTags = this.tempRemoveTags.concat(this.tags);
    this.tags = [];
    this.EnableSave = true;
    this.enableBox = false;
    this.SelectAllStatus = false;
    this.disableSelectAll = true;
    this.disableDelete = true;
  }
  addTag(tag: string, checkDuplicates: boolean, isTempInsert: boolean): void {
    if (this.IsEmpty(tag)) {
      bootbox.alert("Please enter ignore keywords");
    }
    else if (/[@!#$%^&*()\-+={}\[\]|\\/'";:`.,~№?<>]+/i.test(tag) == true || tag.indexOf(' ') >= 0) {
      bootbox.alert("Keyword must be a single word and should contain alphabets only")
    }
    else if (checkDuplicates && (this.indexOf(this.tags, tag.trim()) >= 0)) {
      bootbox.alert("\"" + tag + "\" KeyWord(s) already exists");
    }
    else {
      this.EnableSave = true;
      if (tag[tag.length - 1] === ',' || tag[tag.length - 1] === ' ') {
        tag = tag.slice(0, -1);
        tag = tag || "";
      }
      if (tag.length > 0 && !find(this.tags, tag)) {
        if (isTempInsert) {
          this.tempAddTags.push(tag.trim());
        }
        this.tags.push(tag.trim());
        this.enableBox = true;
        this.disableSelectAll = false;
        this.SelectAllStatus = false;
      }
    }
  }
  removeTag(tag?: string): void {
    this.EnableSave = true;
    if (!!tag) {
      if (this.tempAddTags.indexOf(tag) > -1) {
        pull(this.tempAddTags, tag);
      }
      else {
        this.tempRemoveTags.push(tag.trim());
      }
      pull(this.tags, tag);
    } else {
      this.tags.splice(0, -1);
    }
    if (!(this.tags && this.tags.length > 0)) {
      this.SelectAllStatus = false;
      this.disableSelectAll = true;
      this.disableDelete = true;
      this.enableBox = false;
    }
  }
  LoadIgnoreKeywords() {
    $('.tag-item').css('background', 'none');
    this.tempAddTags = [];
    this.tempRemoveTags = [];
    this.EnableSave = false;
    this.form1.controls.tag.setValue('');
    this.tags = [...new Set(this.tags)];

    if (!(this.tags && this.tags.length > 0)) {
      this.SelectAllStatus = false;
      this.disableSelectAll = true;
      this.disableDelete = true;
      this.enableBox = false;
    }
    else {
      this.SelectAllStatus = false;
      this.disableSelectAll = false;
      this.disableDelete = true;
      this.enableBox = true;
    }
  }
  CancelIgnoreKeywords() {
    if (this.tempAddTags && this.tempAddTags.length > 0) {
      this.tempAddTags.forEach(tag => {
        pull(this.tags, tag);
      });
    }
    if (this.tempRemoveTags && this.tempRemoveTags.length > 0) {
      this.tempAddTags.forEach(tag => {
        pull(this.tempRemoveTags,tag);
      });
      this.tags = this.tags.concat(this.tempRemoveTags);
    }
  }
  SaveIgnoreKeywords() {
    this.spinner.show();
    let that = this;
    let stopKeywords = '';
    if (this.tags && this.tags.length > 0) {
      stopKeywords = this.tags.join(', ');
    }
    var SelectedLanguage = that.sessionService.getSessionStorageItem('SelectedDDLanguage');
    if(SelectedLanguage==null || SelectedLanguage==undefined || SelectedLanguage=='' || SelectedLanguage=='null')
    {
    SelectedLanguage='All';
    }
    this.iomservice.SaveIgnoreKeywords(this.VersionId, stopKeywords, SelectedLanguage).subscribe(data => {
      this.spinner.hide();
      if (data["Response"] == "Success") {
        if (!this.IsProcessEnabled)
          this.IsProcessEnabled = true;
        this.LoadIgnoreKeywords();
        bootbox.alert("Updated Successfully", function () {
          $('.ignoreModelClose').click();
          //if (!this.IsDashboardEnabled)
          //this.IsDashboardEnabled = true;
          //this.loadCategoryTable();
        });
      }
      else {
        bootbox.alert("Timeout. Please Refresh and Try again");
      }
    },
      (err: HttpErrorResponse) => {
        that.spinner.hide();
        bootbox.alert("Timeout. Please Refresh and Try again");
      });
  }
  ToggleCategory(e, catId) {    
    let catObject = this.TicketCatagories.find(x => x.CateId == catId);
    let subCatNames = catObject.SubCategoryDetails.map(x => x.SubCategoryName);
    if(subCatNames.length != 0){
    this.mergedisable = false;    
    if (!$(e.target).parents('.iom-category').find('.iom-editcategory').hasClass('d-none'))
      this.isSubcatOptionsEnabled = true;
    if (!$(e.target).parents('.iom-category').find('.iom-splitcategory').hasClass('d-none'))
      this.isSubcatOptionsEnabled = true;
    if (!$(e.target).parents('.iom-category').find('.iom-newsubcategory').hasClass('d-none'))
      this.isSubcatOptionsEnabled = true;
    if (!$(e.target).parents('.parentdivsubcategory').find('.iom-splitsubcategory').hasClass('d-none'))
      this.isCatOptionsEnabled = true;
    if (!$(e.target).parents('.parentdivsubcategory').find('.iom-editsubcategory').hasClass('d-none'))
      this.isCatOptionsEnabled = true;
    $('.iom-editcategory, .iom-splitcategory').addClass('d-none');
    $('.iom-category-cb').addClass('invisible');
    $('.iom-mergecategory').addClass('d-none');
    $('.iom-category-toggle').removeClass('d-none');    
    $('.iom-newsubcategory').addClass('d-none');
    $('.iom-splitsubcategory').addClass('d-none');
    $(e.target).parents('.iom-category').find('.iom-editcategory').addClass('d-none');
    $(e.target).parents('.iom-category').find('.iom-newsubcategory').addClass('d-none');
    $(e.target).parents('.iom-category').find('.iom-splitcategory').addClass('d-none');
    $(e.target).parents('.iom-category').toggleClass('open');
    $(e.target).parents('.iom-category').find('.iom-subcategory-view').removeClass('d-none');          
      if (subCatNames.length == 1){
        this.mergedisable = true;
      }
      if (subCatNames.length == 2){
        if(catObject.SubCategoryDetails[0].IsSubCategory=="0" || catObject.SubCategoryDetails[1].IsSubCategory=="0")
        {
          this.mergedisable = true;
        }
      }
  }
  else{
    bootbox.alert(" There are no Subcategories for this selected Language");
    return false;
  }       
  }
  TriggerSplit(e, isCategory, catId, subCatId) {
    this.CategoryObj = new Category();
    this.SplitObj = new Category();
    $('.iom-category').not($(e.target).parents('.iom-category')).removeClass('open');
    if (isCategory) {
      this.isSubcatOptionsEnabled = false;
      $(e.target).parents('.iom-category').find('.iom-editcategory').addClass('d-none');
      $(e.target).parents('.iom-category').find('.iom-newsubcategory').addClass('d-none');
      $(e.target).parents('.iom-category').addClass('open').find('.iom-splitcategory').toggleClass('d-none');
      if ($(e.target).parents('.iom-category').find('.iom-splitcategory').hasClass('d-none'))
        this.isSubcatOptionsEnabled = true;
      else {
        let catObject = this.TicketCatagories.find(x => x.CateId == catId);
        this.CategoryObj.CategoryId = catId;
        this.CategoryObj.SubCategoryId = null;
        this.CategoryObj.CategoryName = catObject.CategoryName;
        this.CategoryObj.IsDashboardEnabled = catObject.IsDashboardEnabled;
        this.CategoryObj.ExcludedKeywords = this.getDistinct(catObject.ExcludedKeyWords?.split(',')?.filter(x => x).map(x => x.trim()));
        this.CategoryObj.IncludedKeywords = this.getDistinct(catObject.IncludedKeyWords?.split(',')?.filter(x => x).map(x => x.trim()));
        if (!this.CategoryObj.IncludedKeywords) {
          this.CategoryObj.IncludedKeywords = [];
        }
        if (!this.CategoryObj.ExcludedKeywords) {
          this.CategoryObj.ExcludedKeywords = [];
        }
      }
    }
    else {
      this.isCatOptionsEnabled = false;
      $(e.target).parents('.parentdivsubcategory').find('.iom-editsubcategory').addClass('d-none');
      $(e.target).parents('.parentdivsubcategory').find('.iom-splitsubcategory').toggleClass('d-none');
      if ($(e.target).parents('.parentdivsubcategory').find('.iom-splitsubcategory').hasClass('d-none'))
        this.isCatOptionsEnabled = true;
      else {
        let catObject = this.TicketCatagories.find(x => x.CateId == catId);
        let subcatObject = catObject.SubCategoryDetails.find(x => x.SubCategoryID == subCatId);
        this.CategoryObj.CategoryId = catId;
        this.CategoryObj.SubCategoryId = subcatObject.SubCategoryID;
        this.CategoryObj.CategoryName = subcatObject.SubCategoryName;
        this.CategoryObj.ExcludedKeywords = this.getDistinct(subcatObject.Sub_ExcludedKeyWords?.split(',').filter(x => x).map(x => x.trim()));
        this.CategoryObj.IncludedKeywords = this.getDistinct(subcatObject.Sub_IncludedKeyWords?.split(',').filter(x => x).map(x => x.trim()));
        if (!this.CategoryObj.IncludedKeywords) {
          this.CategoryObj.IncludedKeywords = [];
        }
        if (!this.CategoryObj.ExcludedKeywords) {
          this.CategoryObj.ExcludedKeywords = [];
        }
      }
    }
  }
  TriggerEdit(e, isCategory, catId, subCatId) {
    this.include_enable = false;
    this.CategoryObj = new Category();
    $('.iom-category').not($(e.target).parents('.iom-category')).removeClass('open');
    if (isCategory) {
      this.isSubcatOptionsEnabled = false;
      $(e.target).parents('.iom-category').find('.iom-splitcategory').addClass('d-none');
      $(e.target).parents('.iom-category').find('.iom-newsubcategory').addClass('d-none');
      $(e.target).parents('.iom-category').addClass('open').find('.iom-editcategory').toggleClass('d-none');
      if ($(e.target).parents('.iom-category').find('.iom-editcategory').hasClass('d-none'))
        this.isSubcatOptionsEnabled = true;
      else {
        let catObject = this.TicketCatagories.find(x => x.CateId == catId);
        this.CategoryObj.CategoryId = catId;
        this.CategoryObj.SubCategoryId = null;
        this.CategoryObj.IsDashboardEnabled = catObject.IsDashboardEnabled;
        this.CategoryObj.CategoryName = catObject.CategoryName;
        this.CategoryObj.ExcludedKeywords = this.getDistinct(catObject.ExcludedKeyWords?.split(',')?.filter(x => x).map(x => x.trim()));
        this.CategoryObj.IncludedKeywords = this.getDistinct(catObject.IncludedKeyWords?.split(',')?.filter(x => x).map(x => x.trim()));
        if (this.CategoryObj.IncludedKeywords && this.CategoryObj.IncludedKeywords.length > 0) {
          //this.LoadKeyword(null, this.CategoryObj.IncludedKeywords[0], true, 0);
        }
        else {
          this.CategoryObj.IncludedKeywords = [];
          //this.CategoryObj.includedBtnName = "Add";
        }
        this.CategoryObj.includedBtnName = "Add";
        if (this.CategoryObj.ExcludedKeywords && this.CategoryObj.ExcludedKeywords.length > 0) {
          //this.LoadKeyword(null, this.CategoryObj.ExcludedKeywords[0], false, 0);
        }
        else {
          this.CategoryObj.ExcludedKeywords = [];
          //this.CategoryObj.excludedBtnName = "Add";
        }
        this.CategoryObj.excludedBtnName = "Add";
      }
    }
    else {
      this.isCatOptionsEnabled = false;
      $(e.target).parents('.parentdivsubcategory').find('.iom-splitsubcategory').addClass('d-none');
      $(e.target).parents('.parentdivsubcategory').find('.iom-editsubcategory').toggleClass('d-none');
      if ($(e.target).parents('.parentdivsubcategory').find('.iom-editsubcategory').hasClass('d-none'))
        this.isCatOptionsEnabled = true;
      else {
        let catObject = this.TicketCatagories.find(x => x.CateId == catId);
        let subcatObject = catObject.SubCategoryDetails.find(x => x.SubCategoryID == subCatId);
        this.CategoryObj.CategoryId = catId;
        this.CategoryObj.SubCategoryId = subcatObject.SubCategoryID;
        this.CategoryObj.CategoryName = subcatObject.SubCategoryName;
        this.CategoryObj.ExcludedKeywords = this.getDistinct(subcatObject.Sub_ExcludedKeyWords?.split(',')?.filter(x => x).map(x => x.trim()));
        this.CategoryObj.IncludedKeywords = this.getDistinct(subcatObject.Sub_IncludedKeyWords?.split(',')?.filter(x => x).map(x => x.trim()));
        if (this.CategoryObj.IncludedKeywords && this.CategoryObj.IncludedKeywords.length > 0) {
          //this.LoadKeyword(null, this.CategoryObj.IncludedKeywords[0], true, 0);
        }
        else {
          this.CategoryObj.IncludedKeywords = [];
          //this.CategoryObj.includedBtnName = "Add";
        }
        this.CategoryObj.includedBtnName = "Add";
        if (this.CategoryObj.ExcludedKeywords && this.CategoryObj.ExcludedKeywords.length > 0) {
          //this.LoadKeyword(null, this.CategoryObj.ExcludedKeywords[0], false, 0);
        }
        else {
          this.CategoryObj.ExcludedKeywords = [];
          //this.CategoryObj.excludedBtnName = "Add";
        }
        this.CategoryObj.excludedBtnName = "Add";
      }
    }
  }
  TriggerNewSubcategory(e, categoryId) {
    this.isSubcatOptionsEnabled = false;
    $('.iom-category').not($(e.target).parents('.iom-category')).removeClass('open');
    //$(e.target).parents('.iom-category').find('.iom-subcategory-view').addClass('d-none');
    $(e.target).parents('.iom-category').find('.iom-splitcategory').addClass('d-none');
    $(e.target).parents('.iom-category').addClass('open').find('.iom-newsubcategory').toggleClass('d-none');
    if ($(e.target).parents('.iom-category').find('.iom-newsubcategory').hasClass('d-none'))
      this.isSubcatOptionsEnabled = true;
    else {
      this.CategoryObj = new Category();
      this.CategoryObj.IsDashboardEnabled = true;
      this.CategoryObj.CategoryId = categoryId;
      this.CategoryObj.excludedBtnName = "Add";
      this.CategoryObj.includedBtnName = "Add";
      this.CategoryObj.IncludedKeywords = [];
      this.CategoryObj.ExcludedKeywords = [];
    }
  }
  TriggerMerge(e, isCategory, catId, subCatId) {
    $('.iom-category-cb').find('input[type="checkbox"]').prop('checked', false);
    this.mergeCount = 0;
    let enable = !this.isMergeEnabled;
    this.isMergeEnabled = enable;
    if (isCategory) {
      this.isSubcatOptionsEnabled = false;
      $(e.target).parents('.iom-category').find('.iom-editcategory').addClass('d-none');
      $(e.target).parents('.iom-category').find('.iom-newsubcategory').addClass('d-none');
      $(e.target).parents('.iom-category').find('.iom-splitcategory').addClass('d-none');
      //$('.iom-mergecategory').toggleClass('d-none');
      if (enable) {
        $('.iom-category-toggle').addClass('d-none');
        $('.iom-category').removeClass('open');
        $('.iom-category-cb').toggleClass('invisible');
        $(e.target).parents('.iom-category-head').find('.iom-category-cb').find('input[type="checkbox"]').prop('checked', true);
        this.SelectobjectForMerge($(e.target).parents('.iom-category-head').find('.iom-category-cb').find('input[type="checkbox"]'), isCategory, catId, subCatId, true);
      }
      else {
        this.isSubcatOptionsEnabled = true;
        $('.iom-category-toggle').removeClass('d-none');
        $('.iom-category-cb').addClass('invisible');
        $('.iom-category').removeClass('open');
        $('.iom-mergecategory').addClass('d-none');
        $('#Category_' + this.CategoryObj.CategoryId).removeClass('d-none');
        $('#Category_' + this.MergeObj.CategoryId).removeClass('d-none');
        $('.mergecategorydata').addClass('d-none');
        this.MergeCatBtnText = "Merge";
      }
    }
    else {
      this.isCatOptionsEnabled = false;
      $(e.target).parents('.iom-category').find('.iom-editsubcategory .iom-splitsubcategory').addClass('d-none');
      $(e.target).parents('.iom-category').find('.iom-subcategory-view .iom-category-cb').removeClass('invisible');
      // if ($(e.target).parents('.iom-category').find('.iom-mergesubcategory').hasClass('d-none'))
      //   this.isCatOptionsEnabled = true;
      if (enable) {
        $('.iom-category-toggle').addClass('d-none');
        $(e.target).parents('.parentdivsubcategory').find('.iom-subcategory-view .iom-category-cb').find('input[type="checkbox"]').prop('checked', true);
        this.SelectobjectForMerge($(e.target).parents('.parentdivsubcategory').find('.iom-subcategory-view .iom-category-cb').find('input[type="checkbox"]'), isCategory, catId, subCatId, true);
        //$('.iom-category').removeClass('open');
        //$('.iom-category-cb').toggleClass('invisible');
      }
      else {
        this.isCatOptionsEnabled = true;
        $('.iom-category-toggle').removeClass('d-none');
        $('.iom-category-cb').addClass('invisible');
        $('.iom-category').removeClass('open');
        $('.iom-mergesubcategory').addClass('d-none');
        $('#Subcategory_' + this.CategoryObj.CategoryId + "_" + this.CategoryObj.SubCategoryId).removeClass('d-none');
        $('#Subcategory_' + this.MergeObj.CategoryId + "_" + this.MergeObj.SubCategoryId).removeClass('d-none');
        $('.mergesubcategorydata').addClass('d-none');
        this.MergeSubcatBtnText = "Merge";
      }
    }
  }
  LoadKeyword(e, keyword, isInclude, selectedIndex) {
    let that = this;
    this.ClearTextBoxModel(isInclude);
    if (e != null) {
      $(e.target).parents('.imo-keys').find('div').removeClass("focus-background");
      $(e.target).closest('.imo-keys-list').addClass("focus-background");
    }
    if (isInclude) {
      this.CategoryObj.included_keyword = keyword;
      this.CategoryObj.selectedIndex_included = selectedIndex;
    }
    else {
      this.CategoryObj.excluded_keyword = keyword;
      this.CategoryObj.selectedIndex_excluded = selectedIndex;
    }
    let i = 0;
    let j = 0;
    keyword.split('&').forEach(function (value, index) {
      if (value.indexOf('!') >= 0) {
        switch (i) {
          case 0:
            that.CategoryObj.includeNotContainsText_1 = value.replace('!', '').trim();
            break;
          case 1:
            that.CategoryObj.includeNotContainsText_2 = value.replace('!', '').trim();
            break;
          case 2:
            that.CategoryObj.includeNotContainsText_3 = value.replace('!', '').trim();
            break;
          case 3:
            that.CategoryObj.includeNotContainsText_4 = value.replace('!', '').trim();
            break;
          default:
            break;
        }
        i++;
      }
      else {
        switch (j) {
          case 0:
            if (isInclude)
              that.CategoryObj.includeContainsText_1 = value.replace('!', '').trim();
            else
              that.CategoryObj.excludeText_1 = value.replace('!', '').trim();
            break;
          case 1:
            if (isInclude)
              that.CategoryObj.includeContainsText_2 = value.replace('!', '').trim();
            else
              that.CategoryObj.excludeText_2 = value.replace('!', '').trim();
            break;
          case 2:
            if (isInclude)
              that.CategoryObj.includeContainsText_3 = value.replace('!', '').trim();
            else
              that.CategoryObj.excludeText_3 = value.replace('!', '').trim();
            break;
          case 3:
            if (isInclude)
              that.CategoryObj.includeContainsText_4 = value.replace('!', '').trim();
            else
              that.CategoryObj.excludeText_4 = value.replace('!', '').trim();
            break;
          default:
            break;
        }
        j++;
      }
    });
    if (isInclude)
      this.CategoryObj.includedBtnName = "Update";
    else
      this.CategoryObj.excludedBtnName = "Update";
  }
  AddUpdateKeyword(e, isInclude) {
    let newKeyword = this.GetKeyword(isInclude);  
    var SelectedLanguage = this.sessionService.getSessionStorageItem('SelectedDDLanguage');
    if(SelectedLanguage==null || SelectedLanguage==undefined || SelectedLanguage=='' || SelectedLanguage=='null')
    {
    SelectedLanguage='All';
    }
    let tempKeyword = newKeyword.replace(/ & /g, '');
    if(tempKeyword.indexOf('NoInclude') > -1){
      bootbox.alert("Please enter keyword/s in 'Should include All of the following'");
     return false;
    }
    else if(tempKeyword.indexOf('Numbers are not allowed') > -1){
      bootbox.alert("Numbers are not allowed");
     return false;
    }
    else{
    if (tempKeyword.indexOf(' ') >= 0) {
      bootbox.alert("Space is not allowed")
      return false;
    }
    if (!this.IsEmpty(newKeyword)) {
      if (isInclude) {
        if ((newKeyword.toLowerCase() != this.CategoryObj.included_keyword?.toLowerCase())) {
          if (!this.GetCommon(this.CategoryObj.IncludedKeywords, $.makeArray(newKeyword), " keyword(s) already exists.", false))
            return false;
          if (!this.GetCommon(this.CategoryObj.ExcludedKeywords, $.makeArray(newKeyword), " keyword(s) already exist in Exclude criteria.", false))
            return false;
          if (this.CategoryObj.includedBtnName == "Add") {
            if(this.IsLemmaEnabled)
            {
              let that = this;
              bootbox.confirm({
                message: 'The entered text will be added in the lemmatized form',
                buttons: {
                  confirm: {
                    label: 'Yes',
                    className: 'btn-primary'
                  },
                  cancel: {
                    label: 'No',
                    className: 'btn-secondary'
                  }
                },
                callback: function (result) {
                  if (result) //'Yes' selection
                  {
                    that.spinner.show();
                    that.iomservice.GetLemmaKeywords(that.VersionId,newKeyword,'','',SelectedLanguage).subscribe((data: any) => {
                      that.spinner.hide();
                      if (data.response.Result == "Success") {
                        var LemmaString = data.response.LemmaResponse.KeywordIncluded_Lemma;
                        
                        if (!that.GetCommon(that.CategoryObj.IncludedKeywords, $.makeArray(LemmaString), " keyword(s) already exists.", false))
                        return false;
                        if (!that.GetCommon(that.CategoryObj.ExcludedKeywords, $.makeArray(LemmaString), " keyword(s) already exist in Exclude criteria.", false))
                        return false;
                        that.CategoryObj.IncludedKeywords.push(LemmaString);
                        that.ClearTextBoxModel(isInclude);
                        that.CategoryObj.includedBtnName = "Add";
                      }
                      else {
                        bootbox.alert("Timeout. Please Refresh and Try again");
                      }
                    },
                      (err: HttpErrorResponse) => {
                        that.spinner.hide();
                        bootbox.alert("Timeout. Please Refresh and Try again");
                      });
                  }
                  else //'No' selection
                  {
                    that.CategoryObj.IncludedKeywords.push(newKeyword);
                    that.ClearTextBoxModel(isInclude);
                    that.CategoryObj.includedBtnName = "Add";
                  }
                }
              });
            }
            else{
            this.CategoryObj.IncludedKeywords.push(newKeyword);
            this.ClearTextBoxModel(isInclude);
            this.CategoryObj.includedBtnName = "Add";
            }
          }
          else {
            this.CategoryObj.IncludedKeywords[this.CategoryObj.selectedIndex_included] = newKeyword;
            this.ClearTextBoxModel(isInclude);
            this.CategoryObj.includedBtnName = "Add";
          }
        }
        else {
          this.AddNew(e, isInclude);
        }
      }
      else {
        if ((newKeyword.toLowerCase() != this.CategoryObj.excluded_keyword?.toLowerCase())) {
          if (!this.GetCommon(this.CategoryObj.IncludedKeywords, $.makeArray(newKeyword), " keyword(s) are already exist in Include criteria", false))
            return false;
          if (!this.GetCommon(this.CategoryObj.ExcludedKeywords, $.makeArray(newKeyword), " keyword(s) are already exists.", false))
            return false;
          if (this.CategoryObj.excludedBtnName == "Add") {

            if(this.IsLemmaEnabled)
            {
              let that = this;
              bootbox.confirm({
                message: 'The entered text will be added in the lemmatized form',
                buttons: {
                  confirm: {
                    label: 'Yes',
                    className: 'btn-primary'
                  },
                  cancel: {
                    label: 'No',
                    className: 'btn-secondary'
                  }
                },
                callback: function (result) {
                  if (result) //'Yes' selection
                  {
                    that.spinner.show();
                    that.iomservice.GetLemmaKeywords(that.VersionId,newKeyword,'','',SelectedLanguage).subscribe((data: any) => {
                      that.spinner.hide();
                      if (data.response.Result == "Success") {
                        var LemmaString = data.response.LemmaResponse.KeywordIncluded_Lemma;
                        
                        if (!that.GetCommon(that.CategoryObj.IncludedKeywords, $.makeArray(LemmaString), " keyword(s) are already exist in Include criteria", false))
                        return false;
                        if (!that.GetCommon(that.CategoryObj.ExcludedKeywords, $.makeArray(LemmaString), " keyword(s) are already exists.", false))
                        return false;
                        that.CategoryObj.ExcludedKeywords.push(LemmaString);
                        that.ClearTextBoxModel(isInclude);
                        that.CategoryObj.excludedBtnName = "Add";
                      }
                      else {
                        bootbox.alert("Timeout. Please Refresh and Try again");
                      }
                    },
                      (err: HttpErrorResponse) => {
                        that.spinner.hide();
                        bootbox.alert("Timeout. Please Refresh and Try again");
                      });
                  }
                  else //'No' selection
                  {
                    that.CategoryObj.ExcludedKeywords.push(newKeyword);
                    that.ClearTextBoxModel(isInclude);
                    that.CategoryObj.includedBtnName = "Add";
                  }
                }
              });
            }
            else{
            this.CategoryObj.ExcludedKeywords.push(newKeyword);
            this.ClearTextBoxModel(isInclude);
            this.CategoryObj.excludedBtnName = "Add";
          }
          }
          else {
            this.CategoryObj.ExcludedKeywords[this.CategoryObj.selectedIndex_excluded] = newKeyword;
            this.ClearTextBoxModel(isInclude);
            this.CategoryObj.excludedBtnName = "Add";
          }
        }
        else {
          this.AddNew(e, isInclude);
        }
      }
      // else {
      //   //TODO:
      // }
    }
    else {
      if (isInclude) {
        if (this.CategoryObj.includedBtnName != "Add") {
          let catType = this.TicketCatagories.find(x => x.CateId == this.CategoryObj.CategoryId).CategoryType;
          if (this.CategoryObj.IncludedKeywords?.length == 1 && catType == 'Kmeans') {
            bootbox.alert("Atleast one keyword must be included for the selected opportunity");
            this.LoadKeyword(null, this.CategoryObj.included_keyword, isInclude, this.CategoryObj.selectedIndex_included);
            return false;
          }
          else {
            this.RemoveKeyword(this.CategoryObj.included_keyword, isInclude);
          }
        }
      }
      else {
        if (this.CategoryObj.excludedBtnName != "Add") {
          this.RemoveKeyword(this.CategoryObj.excluded_keyword, isInclude);
        }
      }
    }
    // else {
    //   bootbox.alert("Please fill atleast one criteria");
    // }
  }
}
  ResetKeyword(e, isInclude) {
    $(e.target).parents('.iom-subcategory-section').find('.imo-keys').find('div').removeClass("focus-background");
    this.ClearTextBoxModel(isInclude);
    if (isInclude)
      this.CategoryObj.includedBtnName = "Add";
    else
      this.CategoryObj.excludedBtnName = "Add";
  }
  ClearTextBoxModel(isInclude) {
    if (!isInclude) {
      this.CategoryObj.excludeText_1 = '';
      this.CategoryObj.excludeText_2 = '';
      this.CategoryObj.excludeText_3 = '';
      this.CategoryObj.excludeText_4 = '';
    }
    else {
      this.CategoryObj.includeContainsText_1 = '';
      this.CategoryObj.includeContainsText_2 = '';
      this.CategoryObj.includeContainsText_3 = '';
      this.CategoryObj.includeContainsText_4 = '';
      this.CategoryObj.includeNotContainsText_1 = '';
      this.CategoryObj.includeNotContainsText_2 = '';
      this.CategoryObj.includeNotContainsText_3 = '';
      this.CategoryObj.includeNotContainsText_4 = '';
    }
  }
  GetKeyword(isInclude): string {
    let arrContainsKeywords = [];
    let val = null;
    let Numval = null;
    let arrNotContainsKeywords = [];
    if (isInclude) {
      if(!this.IsEmpty(this.CategoryObj.includeContainsText_1) || !this.IsEmpty(this.CategoryObj.includeContainsText_2) || !this.IsEmpty(this.CategoryObj.includeContainsText_3) || !this.IsEmpty(this.CategoryObj.includeContainsText_4)){
      if (!this.IsEmpty(this.CategoryObj.includeContainsText_1))
        if(this.CategoryObj.includeContainsText_1.match(/^[0-9]+$/) == null)
        arrContainsKeywords.push(this.CategoryObj.includeContainsText_1.trim())
        else
        Numval='Numbers are not allowed';

      if (!this.IsEmpty(this.CategoryObj.includeContainsText_2))
        if(this.CategoryObj.includeContainsText_2.match(/^[0-9]+$/) == null)
          arrContainsKeywords.push(this.CategoryObj.includeContainsText_2.trim())
        else
        Numval='Numbers are not allowed';

      if (!this.IsEmpty(this.CategoryObj.includeContainsText_3))
      if(this.CategoryObj.includeContainsText_3.match(/^[0-9]+$/) == null)
          arrContainsKeywords.push(this.CategoryObj.includeContainsText_3.trim())
        else
        Numval='Numbers are not allowed';

      if (!this.IsEmpty(this.CategoryObj.includeContainsText_4))
         if(this.CategoryObj.includeContainsText_4.match(/^[0-9]+$/) == null)
          arrContainsKeywords.push(this.CategoryObj.includeContainsText_4.trim())
        else
        Numval='Numbers are not allowed';
    }
    else{
      Numval = 'NoInclude';
    }
      if (arrContainsKeywords.length !== 0)
        val = arrContainsKeywords.join(' & ');
      if (!this.IsEmpty(this.CategoryObj.includeNotContainsText_1))
        if(this.CategoryObj.includeNotContainsText_1.match(/^[0-9]+$/) == null)
          arrNotContainsKeywords.push('!' + this.CategoryObj.includeNotContainsText_1.trim())
        else
        Numval='Numbers are not allowed';
        
      if (!this.IsEmpty(this.CategoryObj.includeNotContainsText_2))
        if(this.CategoryObj.includeNotContainsText_2.match(/^[0-9]+$/) == null)
          arrNotContainsKeywords.push('!' + this.CategoryObj.includeNotContainsText_2.trim())
        else
        Numval='Numbers are not allowed';

      if (!this.IsEmpty(this.CategoryObj.includeNotContainsText_3))
         if(this.CategoryObj.includeNotContainsText_3.match(/^[0-9]+$/) == null)
          arrNotContainsKeywords.push('!' + this.CategoryObj.includeNotContainsText_3.trim())
        else
        Numval='Numbers are not allowed';

      if (!this.IsEmpty(this.CategoryObj.includeNotContainsText_4))
        if(this.CategoryObj.includeNotContainsText_4.match(/^[0-9]+$/) == null)
          arrNotContainsKeywords.push('!' + this.CategoryObj.includeNotContainsText_4.trim())
        else
        Numval='Numbers are not allowed';

      if (arrNotContainsKeywords.length !== 0) {
        if (val != null)
          val += ' & ' + arrNotContainsKeywords.join(' & ');
        else
          val = arrNotContainsKeywords.join(' & ');
      }
    }
    else {
      if (!this.IsEmpty(this.CategoryObj.excludeText_1))
        if(this.CategoryObj.excludeText_1.match(/^[0-9]+$/) == null)
          arrContainsKeywords.push(this.CategoryObj.excludeText_1.trim())
        else
          Numval='Numbers are not allowed';
        
      if (!this.IsEmpty(this.CategoryObj.excludeText_2))
        if(this.CategoryObj.excludeText_2.match(/^[0-9]+$/) == null)
          arrContainsKeywords.push(this.CategoryObj.excludeText_2.trim())
        else
          Numval='Numbers are not allowed';

      if (!this.IsEmpty(this.CategoryObj.excludeText_3))
        if(this.CategoryObj.excludeText_3.match(/^[0-9]+$/) == null)
          arrContainsKeywords.push(this.CategoryObj.excludeText_3.trim())
        else
          Numval='Numbers are not allowed';

      if (!this.IsEmpty(this.CategoryObj.excludeText_4))
        if(this.CategoryObj.excludeText_4.match(/^[0-9]+$/) == null)
          arrContainsKeywords.push(this.CategoryObj.excludeText_4.trim())
        else
          Numval='Numbers are not allowed';
          
      if (arrContainsKeywords.length !== 0)
        val = arrContainsKeywords.join(' & ');
    }
    if (!this.IsEmpty(val)) {
      if (!this.GetCommon(arrContainsKeywords, arrNotContainsKeywords, "", true))
        return null;
      else
        if (!this.IsEmpty(Numval))
        return Numval;
        else 
        return val;
    }
    else {
      if (!this.IsEmpty(Numval))
      {
        if(Numval == 'NoInclude'){
          bootbox.alert("Please provide Keywords")
        }
        else{
        bootbox.alert("Numbers are not allowed");
        }
      }
      else{
      if (isInclude) {
        if (this.CategoryObj.includedBtnName == "Add") {
          bootbox.alert("Please fill atleast one inclusion/exclusion criteria");
        }
      }
      else {
        if (this.CategoryObj.excludedBtnName == "Add") {
          bootbox.alert("Please fill atleast one inclusion/exclusion criteria");
        }
      }
    }
      return null;
    }
  }
  AddNew(e, isInclude) {
    if (e != null) {
      $(e.target).parents('.iom-subcategory-section').find('.imo-keys').find('div').removeClass("focus-background");
    }
    this.ClearTextBoxModel(isInclude);
    if (isInclude)
      this.CategoryObj.includedBtnName = "Add";
    else
      this.CategoryObj.excludedBtnName = "Add";
  }
  RemoveKeyword(keyword, isInclude) {
    if (isInclude) {
      let catType = "";
      if(this.CategoryObj.CategoryId!=undefined){
      let catType = this.TicketCatagories.find(x => x.CateId == this.CategoryObj.CategoryId).CategoryType;
      }
      if (this.CategoryObj.IncludedKeywords?.length == 1 && catType == 'Kmeans') {
        bootbox.alert("Atleast one keyword must be included for the selected opportunity");
        return false;
      }
      else {
        this.CategoryObj.IncludedKeywords = this.CategoryObj.IncludedKeywords.filter(v => v !== keyword);
      }
    }
    else
      this.CategoryObj.ExcludedKeywords = this.CategoryObj.ExcludedKeywords.filter(v => v !== keyword);
    this.AddNew(null, isInclude);
  }
  IsEmpty(x) {
    return ((typeof x == 'undefined') || (x === null) || (x === ""));
  }
  getDistinct(arr) {
    if (arr && arr.length > 0) {
      let sorted_arr = arr.slice().sort();
      let results = [];
      results = sorted_arr.filter((v, i, a) => a.indexOf(v) === i);
      // for (let i = 0; i < arr.length - 1; i++) {
      //   if (sorted_arr[i + 1] == sorted_arr[i]) {
      //     results.push(sorted_arr[i]);
      //   }
      // }    
      return results;
    }
    else
      return [];
  }
  getMatch(a, b, notSymbolValidation, copy_a, copy_b) {
    let common: any = [];
    let sameArray: boolean;
    let sorted_a = a.concat().sort();
    $.each(sorted_a, function (i, val) {
      sorted_a[i] = notSymbolValidation != true ? val.toLowerCase() : val.toLowerCase().replace(/!/g, '');
    });
    let copy_sorted_a = copy_a.concat().sort();
    $.each(copy_sorted_a, function (i, val) {
      copy_sorted_a[i] = notSymbolValidation != true ? val.toLowerCase() : val.toLowerCase().replace(/!/g, '');
    });
    let sorted_b = b.concat().sort();
    $.each(sorted_b, function (j, val) {
      sorted_b[j] = notSymbolValidation != true ? val.toLowerCase() : val.toLowerCase().replace(/!/g, '');
    });
    let copy_sorted_b = copy_b.concat().sort();
    $.each(copy_sorted_b, function (i, val) {
      copy_sorted_b[i] = notSymbolValidation != true ? val.toLowerCase() : val.toLowerCase().replace(/!/g, '');
    });
    let tempCommon = [];
    let a_previousLength = sorted_a.length;
    let a_uniqueLength = this.unique(sorted_a).length;
    if (a_previousLength != a_uniqueLength) {
      tempCommon = this.getDistinct(copy_sorted_a);
      sameArray = true;
      common = tempCommon;
    }
    let b_previousLength = sorted_b.length;
    let b_uniqueLength = this.unique(sorted_b).length;
    if (b_previousLength != b_uniqueLength) {
      tempCommon = this.getDistinct(copy_sorted_b);
      sameArray = true;
      common = tempCommon;
    }
    if (common.length <= 0) {
      sameArray = false;
      $.each(sorted_a, function (k, val) {
        if ($.inArray(val, sorted_b) >= 0) {
          common.push(val);
        }
      });
    }
    return [common, sameArray];
  }
  GetCommon(arr1, arr2, msg, notSymbolValidation) {
    let copy_arr1 = arr1;
    let copy_arr2 = arr2;
    let common: any = [];
    if (arr1.length >= arr2.length) {
      common = this.getMatch(arr1, arr2, notSymbolValidation, copy_arr1, copy_arr2);
    }
    else {
      common = this.getMatch(arr2, arr1, notSymbolValidation, copy_arr2, copy_arr1);
    }
    if (common[0].length > 0 && !common[1]) {
      if (msg != '')
        bootbox.alert("\'" + common[0].join('\', \'') + "\'" + msg);
      else
        bootbox.alert('Contains and Does not Contains has same keyword(s).</strong>');
      return false;
    }
    else if (common[0].length > 0 && common[1]) {
      bootbox.alert("Duplicate keyword (\'" + common[0].join('\', \'') + "\') found in Contains/Does Not Contains. Kindly remove duplicates.");
      return false;
    }
    else
      return true;
  }
  SelectKeyword(e, keyword, isInclude, isLeft) {
    if (e != null) {
      $(e.target).parents('.iom-splitcategory').find('div').removeClass("focus-background");
      $(e.target).closest('.imo-keys-list').addClass("focus-background");
    }
    this.SelectedObject = { keyword: keyword, isLeft: isLeft, isInclude: isInclude };
  }
  SwapKeyword(e) {
    if (this.SelectedObject) {
      if (e != null) {
        $(e.target).parents('.iom-splitcategory').find('div').removeClass("focus-background");
      }
      if (this.SelectedObject.isLeft) {
        if (this.SelectedObject.isInclude) {
          this.SplitObj.IncludedKeywords.push(this.SelectedObject.keyword);
          this.CategoryObj.IncludedKeywords = this.CategoryObj.IncludedKeywords.filter(x => x != this.SelectedObject.keyword);
        }
        else {
          this.SplitObj.ExcludedKeywords.push(this.SelectedObject.keyword);
          this.CategoryObj.ExcludedKeywords = this.CategoryObj.ExcludedKeywords.filter(x => x != this.SelectedObject.keyword);
        }
      }
      else {
        if (this.SelectedObject.isInclude) {
          this.CategoryObj.IncludedKeywords.push(this.SelectedObject.keyword);
          this.SplitObj.IncludedKeywords = this.SplitObj.IncludedKeywords.filter(x => x != this.SelectedObject.keyword);
        }
        else {
          this.CategoryObj.ExcludedKeywords.push(this.SelectedObject.keyword);
          this.SplitObj.ExcludedKeywords = this.SplitObj.ExcludedKeywords.filter(x => x != this.SelectedObject.keyword);
        }
      }
      this.SelectedObject = null;
    }
  }
  SelectobjectForMerge(e, isCategory, catId, subCatId, isManual) {
    let target;
    if (isManual) {
      target = e[0];
    }
    else {
      target = e.target;
    }
    if (target.checked) {
      this.mergeCount++;
    }
    else {
      this.mergeCount--;
    }
    switch (this.mergeCount) {
      case 0:
        this.CategoryObj = new Category();
        this.MergeObj = new Category();
        this.TriggerMerge(e, isCategory, 0, 0);
        break;
      case 1:
        this.MergeObj = new Category();
        if (isCategory) {
          $('.iom-mergecategory').addClass('d-none');
          $(target).parents('.parentdivcategory').find('.mergecategorydata').addClass('d-none');
          this.MergeCatBtnText = "Merge";
          if (target.checked) {
            let catObject = this.TicketCatagories.find(x => x.CateId == catId);
            this.CategoryObj.CategoryId = catId;
            this.CategoryObj.SubCategoryId = null;
            this.CategoryObj.CategoryName = catObject.CategoryName;
            this.CategoryObj.TAT = catObject.TATCat;
            this.CategoryObj.IsDashboardEnabled = catObject.IsDashboardEnabled;
            this.CategoryObj.strExcludedKeywords = catObject.ExcludedKeyWords;
            this.CategoryObj.strIncludedKeywords = catObject.IncludedKeyWords;
            this.CategoryObj.Percentage = catObject.Percentage;
            this.CategoryObj.TicketCount = catObject.TicketCount;
            this.CategoryObj.CategoryType = catObject.CategoryType;
          }
          // else {
          //   this.CategoryObj = new Category();
          // }
        }
        else {
          $('.iom-mergesubcategory').addClass('d-none');
          $(target).parents('.parentdivsubcategory').find('.mergesubcategorydata').addClass('d-none');
          this.MergeSubcatBtnText = "Merge";
          if (target.checked) {
            let catObject = this.TicketCatagories.find(x => x.CateId == catId);
            let subcatObject = catObject.SubCategoryDetails.find(x => x.SubCategoryID == subCatId);
            this.CategoryObj.CategoryId = catId;
            this.CategoryObj.SubCategoryId = subcatObject.SubCategoryID;
            this.CategoryObj.TAT = subcatObject.TATSubCat;
            this.CategoryObj.CategoryName = subcatObject.SubCategoryName;
            this.CategoryObj.strExcludedKeywords = subcatObject.Sub_ExcludedKeyWords;
            this.CategoryObj.strIncludedKeywords = subcatObject.Sub_IncludedKeyWords;
            this.CategoryObj.Percentage = subcatObject.Sub_Percentage;
            this.CategoryObj.TicketCount = subcatObject.Sub_TicketCount;
          }
          // else {
          //   this.CategoryObj = new Category();
          // }
        }
        break;
      case 2:
        this.MergeObj = new Category();
        if (isCategory) {
          $(target).parents('.parentdivcategory').find('.iom-mergecategory').toggleClass('d-none');
          $(target).parents('.parentdivcategory').find('.mergecategorydata').addClass('d-none');
          let catObject = this.TicketCatagories.find(x => x.CateId == catId);
          this.MergeObj.CategoryId = catId;
          this.MergeObj.SubCategoryId = null;
          this.MergeObj.CategoryName = catObject.CategoryName;
          this.MergeObj.TAT = catObject.TATCat;
          this.MergeObj.IsDashboardEnabled = catObject.IsDashboardEnabled;
          this.MergeObj.strExcludedKeywords = catObject.ExcludedKeyWords;
          this.MergeObj.strIncludedKeywords = catObject.IncludedKeyWords;
          this.MergeObj.Percentage = catObject.Percentage;
          this.MergeObj.TicketCount = catObject.TicketCount;
          this.MergeObj.CategoryType = catObject.CategoryType;
        }
        else {
          $(target).parents('.parentdivsubcategory').find('.iom-mergesubcategory').toggleClass('d-none');
          $(target).parents('.parentdivsubcategory').find('.mergesubcategorydata').addClass('d-none');
          let catObject = this.TicketCatagories.find(x => x.CateId == catId);
          let subcatObject = catObject.SubCategoryDetails.find(x => x.SubCategoryID == subCatId);
          this.MergeObj.CategoryId = catId;
          this.MergeObj.SubCategoryId = subcatObject.SubCategoryID;
          this.MergeObj.CategoryName = subcatObject.SubCategoryName;
          this.MergeObj.TAT = subcatObject.TATSubCat;
          this.MergeObj.strExcludedKeywords = subcatObject.Sub_ExcludedKeyWords;
          this.MergeObj.strIncludedKeywords = subcatObject.Sub_IncludedKeyWords;
          this.MergeObj.Percentage = subcatObject.Sub_Percentage;
          this.MergeObj.TicketCount = subcatObject.Sub_TicketCount;
        }
        break;
      case 3:
        bootbox.alert('More than two ' + (isCategory ? "categories" : "subcategories") + " cannot be merged");
        target.checked = false;
        this.mergeCount--;
        break;
      default:
        break;
    }
  }
  MergeData(e, isCategory) {
    if (isCategory) {
      if (this.MergeCatBtnText != "Save") {
        if (this.CategoryObj.CategoryType == "Standard" || this.CategoryObj.CategoryType == "Standard") {
          bootbox.alert("Cannot combine Standard Category");
        }
        else {
          this.DoMerge();
          this.MergeCatBtnText = "Save";
          $('#Category_' + this.CategoryObj.CategoryId).addClass('d-none');
          $('#Category_' + this.MergeObj.CategoryId).addClass('d-none');
          $(e.target).parents('.parentdivcategory').find('.mergecategorydata').removeClass('d-none');
          $('.iom-category-cb').toggleClass('invisible');
          $('#catNameTextBox').focus();
        }
      }
      else {
        this.SaveMerge(true);
      }
    }
    else {
      if (this.MergeSubcatBtnText != "Save") {
        this.DoMerge();
        this.MergeSubcatBtnText = "Save";
        $('#Subcategory_' + this.CategoryObj.CategoryId + '_' + this.CategoryObj.SubCategoryId).addClass('d-none');
        $('#Subcategory_' + this.MergeObj.CategoryId + '_' + this.MergeObj.SubCategoryId).addClass('d-none');
        $(e.target).parents('.parentdivsubcategory').find('.mergesubcategorydata').removeClass('d-none');
        $('.iom-subcategory-view .iom-category-cb').toggleClass('invisible');
        $('#subCatNameTextBox').focus();
      }
      else {
        this.SaveMerge(false);
      }
    }
  }
  DoMerge() {
    let uniqueKeywords = [];
    this.MergeObj.TicketCount = this.CategoryObj.TicketCount + this.MergeObj.TicketCount;
    //this.MergeObj.Percentage = this.CategoryObj.Percentage + this.MergeObj.Percentage;
    this.MergeObj.Percentage =  parseFloat(this.CategoryObj.Percentage + this.MergeObj.Percentage).toFixed(2);
    this.MergeObj.strIncludedKeywords = this.CategoryObj.strIncludedKeywords + ', ' + this.MergeObj.strIncludedKeywords;
    this.MergeObj.strIncludedKeywords = this.MergeObj.strIncludedKeywords?.replace(/null/g, '')
    uniqueKeywords = this.getDistinct(this.MergeObj.strIncludedKeywords.toLowerCase().split(',').filter(x => x).map(x => x.trim()).sort());
    uniqueKeywords = uniqueKeywords?.filter(x => x);
    this.MergeObj.strIncludedKeywords = uniqueKeywords?.join(', ').trim();
    this.MergeObj.strExcludedKeywords = this.CategoryObj.strExcludedKeywords + ', ' + this.MergeObj.strExcludedKeywords;
    this.MergeObj.strExcludedKeywords = this.MergeObj.strExcludedKeywords?.replace(/null/g, '')
    uniqueKeywords = [];
    uniqueKeywords = this.getDistinct(this.MergeObj.strExcludedKeywords.toLowerCase().split(',').filter(x => x).map(x => x.trim()).sort());
    uniqueKeywords = uniqueKeywords?.filter(x => Boolean(x));
    this.MergeObj.strExcludedKeywords = uniqueKeywords?.join(', ').trim();
    this.MergeObj.strExcludedKeywords = (this.MergeObj.strExcludedKeywords == "," || this.MergeObj.strExcludedKeywords == "") ? null : this.MergeObj.strExcludedKeywords;
    this.MergeObj.strIncludedKeywords = (this.MergeObj.strIncludedKeywords == "," || this.MergeObj.strIncludedKeywords == "") ? null : this.MergeObj.strIncludedKeywords;
    // this.MergeObj.ExcludedKeywords = this.MergeObj.strExcludedKeywords?.split(', ');
    // this.MergeObj.IncludedKeywords = this.MergeObj.strIncludedKeywords?.split(', ');
    this.MergeObj.IsDashboardEnabled = true;
    this.MergeObj.TAT = this.CategoryObj.TAT + this.MergeObj.TAT;
    this.MergeObj.CategoryName = this.CategoryObj.CategoryName + "/" + this.MergeObj.CategoryName;
  }
  ValidateOpportunityName(catName, oldCatName, isCategory, flag, subCatNames, language): boolean {
    if(!this.IsEmpty(catName) && !isNaN(catName)){
      bootbox.alert("Numbers are not allowed");
     return false;
    }
    else{
    if (this.IsEmpty(catName)) {
      bootbox.alert("Please Enter the " + (isCategory ? "Category" : "Subcategory") + " name");
      return false;
    }
    if (!this.IsEmpty(catName) && catName.split(/\s+/).length >250) {
      bootbox.alert((isCategory ? "Category" : "Subcategory") + " name should be less then 250 words");
      return false;
    }
    // else if ((/^[a-zA-Z0-9-/_&\s]*$/.test(catName)) == false && language == 'English') { //((/[0-9]/.test(catName)) == true || 
    //   bootbox.alert("The entered opportunity must have alphabets");
    //   return false;
    // }
    // else if(language=='English'){
    //   bootbox.alert((isCategory ? "Category" : "Subcategory") + " Name " + "\"" + catName + "\" must have Alphabets");
    //   return false;
    //   }   
    else if((/[a-zA-Z0-9]/.test(catName)) == true || language != 'English')   {
      this.AllCategoryNames = this.AllCategoryNames?.map(function (v) {
        return v.toLowerCase();
      });
      subCatNames = subCatNames?.map(function (v) {
        return v.toLowerCase();
      });
      if (flag != 'edit') {
        if (isCategory) {
          if (this.indexOf(this.AllCategoryNames, catName.trim()) >= 0) {
            bootbox.alert("The Category \"" + catName + "\" already Exists..");
            return false;
          }
        }
        else {
          if (this.indexOf(subCatNames, catName.trim()) >= 0) {
            bootbox.alert("The Subcategory \"" + catName + "\" already Exists..");
            return false;
          }
        }
      }
      else {
        if (catName != oldCatName) {
          if (isCategory) {
            if (this.indexOf(this.AllCategoryNames, catName) >= 0) {
              bootbox.alert("The Category \"" + catName + "\" already Exists..");
              return false;
            }
          }
          else {
            if (this.indexOf(subCatNames, catName) >= 0) {
              bootbox.alert("The Subcategory \"" + catName + "\" already Exists..");
              return false;
            }
          }
        }
      }
      return true;
    }
    else {
      if(language=='English'){
      bootbox.alert((isCategory ? "Category" : "Subcategory") + " Name " + "\"" + catName + "\" must have Alphabets");
      return false;
      }
    }    
    return true;
  }
  }
  SaveEdit(isCategory, oldCatSubcatName, catType) {
    let subCatNames = this.TicketCatagories.find(x => x.CateId == this.CategoryObj.CategoryId).SubCategoryDetails.map(x => x.SubCategoryName);
    if (!subCatNames)
      subCatNames = [];
    let isNameChangeOnly = false;
    if (isCategory) {
      if (this.IsKmeans && catType == 'Kmeans') {
        isNameChangeOnly = false;
        if (!(this.CategoryObj.IncludedKeywords && this.CategoryObj.IncludedKeywords.length >= 1)) {
          bootbox.alert("Atleast one keyword must be added in 'keyword considered' section for the selected opportunity");
          return false;
        }
      }
      else {
        isNameChangeOnly = this.categoryNameEditOnly;
      }
    }
    else {
      isNameChangeOnly = (this.subCategoryNameEditOnly || (this.IsKmeans && catType != 'Kmeans'));
      if (this.IsKmeans && catType == 'Kmeans') {
        if (!(this.CategoryObj.IncludedKeywords && this.CategoryObj.IncludedKeywords.length >= 1)) {
          bootbox.alert("Atleast one keyword must be added in 'keyword considered' section for the selected opportunity");
          return false;
        }
      }
    }
    if (this.ValidateOpportunityName(this.CategoryObj.CategoryName, oldCatSubcatName, isCategory, 'edit', subCatNames,this.envVar.EnableLanguage ?  this.Language : 'English')) {
      this.spinner.show();
      this.InsertUpdateOpportunityData(this.VersionId, this.CategoryObj.CategoryId, this.CategoryObj.SubCategoryId, 0, 0, this.CategoryObj.CategoryName.trim(), this.CategoryObj.IsDashboardEnabled, this.CategoryObj.IncludedKeywords?.filter(x => Boolean(x)).join(', '), this.CategoryObj.ExcludedKeywords?.filter(x => Boolean(x)).join(', '), '', 'edit', '', '', !isCategory, isNameChangeOnly, catType,this.envVar.EnableLanguage ?  this.Language : 'English');
      }
  }
  SaveSplit(isCategory, oldCatSubcatName) {
    let categoryObj = this.TicketCatagories.find(x => x.CateId == this.CategoryObj.CategoryId);
    let subCatNames = categoryObj.SubCategoryDetails.map(x => x.SubCategoryName);
    let catType = categoryObj.CategoryType;
    if (!subCatNames)
      subCatNames = [];
    if (isCategory) {
      if (this.IsKmeans && catType == 'Kmeans') {
        if (!(this.CategoryObj.IncludedKeywords && this.CategoryObj.IncludedKeywords.length >= 1)) {
          bootbox.alert("Atleast one keyword must be added in 'keyword considered' section for the source opportunity");
          return false;
        }
        if (!(this.SplitObj.IncludedKeywords && this.SplitObj.IncludedKeywords.length >= 1)) {
          bootbox.alert("Atleast one keyword must be added in 'keyword considered' section for the new opportunity");
          return false;
        }
      }
    }
    else {
      if (this.IsKmeans && catType == 'Kmeans') {
        if (!(this.CategoryObj.IncludedKeywords && this.CategoryObj.IncludedKeywords.length >= 1)) {
          bootbox.alert("Atleast one keyword must be added in 'keyword considered' section for the source opportunity");
          return false;
        }
        if (!(this.SplitObj.IncludedKeywords && this.SplitObj.IncludedKeywords.length >= 1)) {
          bootbox.alert("Atleast one keyword must be added in 'keyword considered' section for the new opportunity");
          return false;
        }
      }
    }
    if (this.ValidateOpportunityName(this.CategoryObj.CategoryName, oldCatSubcatName, isCategory, 'edit', subCatNames,this.envVar.EnableLanguage ?  this.Language : 'English' ) && this.ValidateOpportunityName(this.SplitObj.CategoryName, '', isCategory, 'split', subCatNames,this.envVar.EnableLanguage ?  this.Language : 'English')) {
      this.spinner.show();
      this.InsertUpdateOpportunityData(this.VersionId, this.CategoryObj.CategoryId, this.CategoryObj.SubCategoryId, 0, 0, this.CategoryObj.CategoryName, this.CategoryObj.IsDashboardEnabled, this.CategoryObj.IncludedKeywords?.filter(x => Boolean(x)).join(', '), this.CategoryObj.ExcludedKeywords?.filter(x => Boolean(x)).join(', '), this.SplitObj.CategoryName, 'split', this.SplitObj.IncludedKeywords?.filter(x => Boolean(x)).join(', '), this.SplitObj.ExcludedKeywords?.filter(x => Boolean(x)).join(', '), !isCategory, false, catType, this.envVar.EnableLanguage ?  this.Language : 'English' );
    }
  }
  SaveMerge(isCategory) {
    // let subCatNames1 = this.TicketCatagories.find(x => x.CategoryId == this.CategoryObj.CategoryId).SubCategoryDetails.map(x => x.SubCategoryName);
    // let subCatNames2 = this.TicketCatagories.find(x => x.CategoryId == this.MergeObj.CategoryId).SubCategoryDetails.map(x => x.SubCategoryName);
    // let subCatNames = subCatNames1.concat(subCatNames2);
    let categoryObj = this.TicketCatagories.find(x => x.CateId == this.CategoryObj.CategoryId);
    let subCatNames = categoryObj.SubCategoryDetails.map(x => x.SubCategoryName);
    let catType = categoryObj.CategoryType;
    if (!subCatNames)
      subCatNames = [];
    // else
    //   subCatNames = this.unique(subCatNames);
    let combineCategoryId_1 = null;
    let combineCategoryId_2 = null;
    if (isCategory) {
      combineCategoryId_1 = this.CategoryObj.CategoryId;
      combineCategoryId_2 = this.MergeObj.CategoryId;
    }
    else {
      combineCategoryId_1 = this.CategoryObj.SubCategoryId;
      combineCategoryId_2 = this.MergeObj.SubCategoryId;
    }
    this.MergeObj.IncludedKeywords = this.getDistinct(this.MergeObj.strIncludedKeywords?.split(',')?.filter(x => x).map(x => x.trim()));
    if (isCategory) {
      if (this.IsKmeans && catType == 'Kmeans') {
        if (!(this.MergeObj.IncludedKeywords && this.MergeObj.IncludedKeywords.length >= 1)) {
          bootbox.alert("Atleast one keyword must be added in 'keyword considered' section for the selected opportunity");
          return false;
        }
      }
    }
    else {
      if (this.IsKmeans && catType == 'Kmeans') {
        if (!(this.MergeObj.IncludedKeywords && this.MergeObj.IncludedKeywords.length >= 1)) {
          bootbox.alert("Atleast one keyword must be added in 'keyword considered' section for the selected opportunity");
          return false;
        }
      }
    }
    if (this.ValidateOpportunityName(this.MergeObj.CategoryName, '', isCategory, 'merge', subCatNames,this.envVar.EnableLanguage ?  this.Language : 'English' )) {
      this.spinner.show();
      this.InsertUpdateOpportunityData(this.VersionId, this.CategoryObj.CategoryId, 0, combineCategoryId_1, combineCategoryId_2, this.MergeObj.CategoryName, this.CategoryObj.IsDashboardEnabled, this.MergeObj.strIncludedKeywords, this.MergeObj.strExcludedKeywords, '', 'combine', '', '', !isCategory, false, catType, this.envVar.EnableLanguage ?  this.Language : 'English' );
    }
  }
  SaveNew(isCategory) {
    let subCatNames = [];
    let isNameChangeOnly = false;
    let catType = null;
    if (!isCategory) {
      let categoryObj = this.TicketCatagories.find(x => x.CateId == this.CategoryObj.CategoryId);
      subCatNames = categoryObj.SubCategoryDetails.map(x => x.SubCategoryName);
      catType = categoryObj.CategoryType;
    }
    if (!subCatNames)
      subCatNames = [];
    if (isCategory) {
      if (this.IsKmeans && catType == 'Kmeans') {
        if (!(this.CategoryObj.IncludedKeywords && this.CategoryObj.IncludedKeywords.length >= 1)) {
          bootbox.alert("Atleast one keyword must be added in 'keyword considered' section for the new opportunity"); // '" + this.CategoryObj.CategoryName + "'
          return false;
        }
      }
    }
    else {
      if (this.IsKmeans && catType == 'Kmeans') {
        if (!(this.CategoryObj.IncludedKeywords && this.CategoryObj.IncludedKeywords.length >= 1)) {
          bootbox.alert("Atleast one keyword must be added in 'keyword considered' section for the new opportunity");
          return false;
        }
      }
    }
    if (this.ValidateOpportunityName(this.CategoryObj.CategoryName, '', isCategory, 'new', subCatNames,this.envVar.EnableLanguage ?  this.Language : 'English' )) {
      this.spinner.show();
      this.InsertUpdateOpportunityData(this.VersionId, this.CategoryObj.CategoryId, this.CategoryObj.SubCategoryId, 0, 0, this.CategoryObj.CategoryName, this.CategoryObj.IsDashboardEnabled, this.CategoryObj.IncludedKeywords?.filter(x => Boolean(x)).join(', '), this.CategoryObj.ExcludedKeywords?.filter(x => Boolean(x)).join(', '), '', 'new', '', '', !isCategory, isNameChangeOnly, catType, this.envVar.EnableLanguage ?  this.Language : 'English' );
    }
  }
  InsertUpdateOpportunityData(VersionId, CategoryId, SubCategoryId, CmbnCategoryId1, CmbnCategoryId2, CategoryName, IsDashboardEnabled, IncludedKeywords, ExcludedKeywords, New_categoryName, Flag, Insert_IncludedKeywordText, Insert_ExcludedKeywordText, IsSubCategory, isNameChangeOnly = false, catType, Language) {
    let that = this;
    var SelectedLanguage = that.sessionService.getSessionStorageItem('SelectedDDLanguage');
    if(SelectedLanguage==null || SelectedLanguage==undefined || SelectedLanguage=='' || SelectedLanguage=='null')
    {
    SelectedLanguage='All';
    }
    this.iomservice.InsertUpdateOpportunityData(VersionId, CategoryId, SubCategoryId, CmbnCategoryId1, CmbnCategoryId2, CategoryName, IsDashboardEnabled, IncludedKeywords, ExcludedKeywords, New_categoryName, Flag, Insert_IncludedKeywordText, Insert_ExcludedKeywordText, IsSubCategory, isNameChangeOnly, catType, this.IsKmeans, SelectedLanguage).subscribe((data: any) => {      
      this.spinner.hide();
      if (data.Response == "Success") {
        bootbox.alert("Updated Successfully", function () {
          if (Flag == 'combine') {
            that.isMergeEnabled = false;
          }
          if (Flag == 'new' && !IsSubCategory) {
            that.loadCategoryTable();
          }
          $('.editCatModelClose').click();
          //call automatiommitigation api to fetch the data again
          that.spinner.show();
          that.GetCategoryandSubcategoryData(that.VersionId, false);
        });
      }
      else if (data.Response == "Failure") {
        bootbox.alert("Timeout. Please Refresh and Try again");
      }
      else {
        bootbox.alert(data.Response);
      }
    },
      (err: HttpErrorResponse) => {
        that.spinner.hide();
        bootbox.alert("Timeout. Please Refresh and Try again");
      });
  }
  Cancel(e, flag, isCategory) {
    switch (flag) {
      case "new":
        this.TriggerNewSubcategory(e, 0);
        break;
      case "edit":
        this.TriggerEdit(e, isCategory, 0, 0);
        break;
      case "split":
        this.TriggerSplit(e, isCategory, 0, 0);
        break;
      case "merge":
        this.TriggerMerge(e, isCategory, 0, 0);
        break;
      default:
        break;
    }
  }
  ChangeDashboardFlag(e, catId, catName, TotalTicketCount) {
    let nmbr = 0;
    var IsDashboardEnabled = $(e.target).prop('checked');
    let dashboardElements = $('.dashboardtoggle');
    $.each(dashboardElements, function (index, item) {
      if (dashboardElements[index].checked)
        nmbr++;
    });
    if (nmbr >= 1) {
      this.spinner.show();
      this.iomservice.UpdateDashboardEnabled(this.VersionId, catId, IsDashboardEnabled, catName, TotalTicketCount).subscribe((data: any) => {
        this.spinner.hide();
        if (data.Response != "Success") {
          bootbox.alert("Timeout. Please Refresh and Try again");
          $(e.target).prop('checked', !IsDashboardEnabled);
        }
        else {
          this.messageService.loadViewDetails(true);
        }
      },
        (err: HttpErrorResponse) => {
          this.spinner.hide();
          $(e.target).prop('checked', !IsDashboardEnabled);
          bootbox.alert("Timeout. Please Refresh and Try again");
        });
    }
    else {
      bootbox.alert("There should be at least one category enabled");
      $(e.target).prop('checked', !IsDashboardEnabled);
    }
  }
  Recategorize() {
    let that = this;
    if(this.activefilter == true) 
    bootbox.alert("There are some active filters, please remove all filters before proceeding.") 
    else if(this.ClassificationTypeId == 2 && this.OnKeyupClusters()==false)
    {

    }
    else if(this.ClassificationTypeId == 2 && this.OnKeyupExitCondition(true)==false)
    {
      
    }
  else
  var recategorizeMsg = 'Any recategorization done earlier will be replaced and new opportunities will be computed based on lemmatization checkbox select/unselect.<br />Are you sure on processing the modified categories?<br /> Click on "Yes" to proceed and you will be redirected to Home page while processing your tickets';
  if(this.Language == 'Chinese')
  {
    recategorizeMsg = 'Are you sure on processing the modified categories?<br /> Click on "Yes" to proceed and you will be redirected to Home page while processing your tickets';
  }
  
    bootbox.confirm({
      message: recategorizeMsg,
      buttons: {
        confirm: {
          label: 'Yes',
          className: 'btn-primary'
        },
        cancel: {
          label: 'No',
          className: 'btn-secondary'
        }
      },
      callback: function (result) {
        if (result) //'Yes' selection
        {
          that.sessionService.setSessionStorageItem("IsLemmaChecked", "0");
          that.spinner.show();
          //remove existing keywords
          if(that.IsLemmaChecked)
          {
            var SelectedLanguage = that.sessionService.getSessionStorageItem('SelectedDDLanguage');
            if(SelectedLanguage==null || SelectedLanguage==undefined || SelectedLanguage=='' || SelectedLanguage=='null')
            {
            SelectedLanguage='All';
            }
            that.iomservice.SaveIgnoreKeywords(that.VersionId, '',SelectedLanguage).subscribe(data => {                    
          },
            (err: HttpErrorResponse) => {
              that.spinner.hide();
              bootbox.alert("Timeout. Please Refresh and Try again");
            });
          }
          var SelectedLanguage = that.sessionService.getSessionStorageItem('SelectedDDLanguage');
          if(SelectedLanguage==null || SelectedLanguage==undefined || SelectedLanguage=='' || SelectedLanguage=='null')
          {
            SelectedLanguage='All';
          }
          that.iomservice.TriggerClassification(that.VersionId, that.NoofCluster, that.ExitCondition, that.IsLemmaEnabled,SelectedLanguage).subscribe((data: any) => {                      
            that.spinner.hide();
            if (data.Response == "Success") {
              that.messageService.updateDDredirection('reclassified')              
            }
            else {
              bootbox.alert("Timeout. Please Refresh and Try again");
            }
          },
            (err: HttpErrorResponse) => {
              that.spinner.hide();
              bootbox.alert("Timeout. Please Refresh and Try again");
            });
        }
        else //'No' selection
        {
          //TODO:
        }
      }
    });
  }
  OnKeypressShouldInclude(e){
    // !/^[a-zA-Z0-9]*$/.test(String.fromCharCode(e.which)) ||
    if (e.which === 32 || /^[!@#$%^&*<>+=()~?[]]*$/.test(String.fromCharCode(e.which))) //$('#' + e.target.id).val() //String.fromCharCode(e.which).match(/^[a-zA-Z0-9]*$/) && String.fromCharCode(e.which).match(/^[\/?*|"<>:]*$/)) ) //$('#' + e.target.id).val() //String.fromCharCode(e.which).match(/^[a-zA-Z0-9]*$/) && String.fromCharCode(e.which).match(/^[\/?*|"<>:]*$/))
    {
      bootbox.alert("Space and Special characters are not allowed");
      return false;
    }
    this.include_enable = true;
  }
  OnKeypressIncludeExclude(e) {
    // !/^[a-zA-Z0-9]*$/.test(String.fromCharCode(e.which)) ||
    if (e.which === 32 || /^[!@#$%^&*<>+=()~?[]]*$/.test(String.fromCharCode(e.which))) //$('#' + e.target.id).val() //String.fromCharCode(e.which).match(/^[a-zA-Z0-9]*$/) && String.fromCharCode(e.which).match(/^[\/?*|"<>:]*$/))) //$('#' + e.target.id).val() //String.fromCharCode(e.which).match(/^[a-zA-Z0-9]*$/) && String.fromCharCode(e.which).match(/^[\/?*|"<>:]*$/))
    {
      bootbox.alert("Space and Special characters are not allowed");
      return false;
    }
  }

  OnKeypressIncludeExcludeIgnoreKeyword(e) {
  //   if((this.envVar.EnableLanguage ? this.Language : 'English' ) == 'English'){
  //   if (e.which === 32 || e.which === 33 || e.which === 38 || !/^[a-zA-Z0-9]*$/.test(String.fromCharCode(e.which)) || /^[!@#$%^&*<>+=()~?[]]*$/.test(String.fromCharCode(e.which))) //$('#' + e.target.id).val() //String.fromCharCode(e.which).match(/^[a-zA-Z0-9]*$/) && String.fromCharCode(e.which).match(/^[\/?*|"<>:]*$/))) //$('#' + e.target.id).val() //String.fromCharCode(e.which).match(/^[a-zA-Z0-9]*$/) && String.fromCharCode(e.which).match(/^[\/?*|"<>:]*$/))
  //   {
  //     bootbox.alert("Space and Special characters are not allowed");
  //     return false;
  //   }
  // }
  // else {
    if (e.which === 32 || /^[!@#$%^&*<>+=()~?[]]*$/.test(String.fromCharCode(e.which))) //$('#' + e.target.id).val() //String.fromCharCode(e.which).match(/^[a-zA-Z0-9]*$/) && String.fromCharCode(e.which).match(/^[\/?*|"<>:]*$/))) //$('#' + e.target.id).val() //String.fromCharCode(e.which).match(/^[a-zA-Z0-9]*$/) && String.fromCharCode(e.which).match(/^[\/?*|"<>:]*$/))
    {
      bootbox.alert("Space and Special characters are not allowed");
      return false;
    }
  }
  // }
 
  OnKeypressIncludeSpace(e) {
    if (/^[!@#$%^&*<>+=()~?[]]*$/.test(String.fromCharCode(e.which))) //$('#' + e.target.id).val() //String.fromCharCode(e.which).match(/^[a-zA-Z0-9]*$/) && String.fromCharCode(e.which).match(/^[\/?*|"<>:]*$/))
    {
      bootbox.alert("Special characters and Only Numbers are not allowed");
      return false;
    }
  }
  unique(list) {
    var result = [];
    let that = this;
    $.each(list, function (i, e) {
      if (e) {
        if (that.indexOf(result, e.trim()) == -1) result.push(e);
      }
    });
    return result;
  }

  //validate category is not empty
  OnKeyupCategoryname() {
    if(this.CategoryObj.CategoryName.length == 0)
    this.reenabled = false
    if(this.CategoryObj.CategoryName.length != 0)
    this.reenabled = true
  }

  //Validation Check for No of Clusters TextBox, enabling Process Button
  OnKeyupClusters() {
    if (this.NoofCluster != 0) {
      if ((/^[0-9]*$/.test(this.NoofCluster.toString())) == false) {
        bootbox.alert("No of Clusters must be a numeric!");
        this.NoofCluster = parseInt(this.NoofCluster.toString().slice(0, -1));
        this.NoofCluster = this.NoofCluster || null;
        return false;
      }
      else if (this.NoofCluster <= 0) {
        bootbox.alert("No of Clusters must be greater than 0!");
        this.NoofCluster = parseInt(this.NoofCluster.toString().slice(0, -1));
        this.NoofCluster = this.NoofCluster || null;
        return false;
      }
      else if (this.NoofCluster.toString().length > 2) {
        bootbox.alert("No of Clusters must not be greater than 99!");
        this.NoofCluster = parseInt(this.NoofCluster.toString().slice(0, -1));
        this.NoofCluster = this.NoofCluster || null;
        return false;
      }
      if (!this.IsProcessEnabled_old) {
        this.CheckClassificationCriteriaChange(this.NoofCluster, this.NoofCluster_Old, this.ExitCondition, this.ExitCondition_Old, false, true);
      }
      //this.IsProcessEnabled = true;
      return true;
    }
    else {
      bootbox.alert("No of Clusters should not be empty");
      this.IsProcessEnabled = false;
      return false;
    }
  }

  //Validation Check for ExitCondition TextBox, enabling Process Button
  OnKeyupExitCondition(isFDS) {
    if (this.ExitCondition != 0) {
      if (isFDS) {
        if ((/^[0-9]*$/.test(this.ExitCondition.toString())) == false) {
          bootbox.alert("Allowed maximum % of unclassified tickets must be a numeric!");
          this.ExitCondition = parseInt(this.ExitCondition.toString().slice(0, -1));
          this.ExitCondition = this.ExitCondition || null;
        //  this.IsProcessEnabled = true;
          return false;
        }
        else if (this.ExitCondition <= 0) {
          bootbox.alert("Allowed maximum % of unclassified tickets should be greater than 0!");
          this.ExitCondition = parseInt(this.ExitCondition.toString().slice(0, -1));
          this.ExitCondition = this.ExitCondition || null;
          return false;
        }
        else if (this.ExitCondition > 100) {
          bootbox.alert("Allowed maximum % of unclassified tickets should not be greater than 100!");
          this.ExitCondition = parseInt(this.ExitCondition.toString().slice(0, -1));
          this.ExitCondition = this.ExitCondition || null;
          return false;
        }
      }
      else {
        if ((/^[0-9]*$/.test(this.ExitCondition.toString())) == false) {
          bootbox.alert("Exit Condition must be a numeric!");
          this.ExitCondition = parseInt(this.ExitCondition.toString().slice(0, -1));
          this.ExitCondition = this.ExitCondition || null;
          return false;
        }
        else if (this.ExitCondition.toString().length > 6) {
          bootbox.alert("Exit Condition must not be greater than 999999!");
          this.ExitCondition = parseInt(this.ExitCondition.toString().slice(0, -1));
          this.ExitCondition = this.ExitCondition || null;
          return false;
        }
      }
      if (!this.IsProcessEnabled_old) {
        this.CheckClassificationCriteriaChange(this.NoofCluster,this.NoofCluster_Old, this.ExitCondition, this.ExitCondition_Old, false, false);
      }
      //this.IsProcessEnabled = true;
      return true;
    }
    else {
      bootbox.alert("Allowed maximum % of unclassified tickets should not be empty");
      this.IsProcessEnabled = false;
      return false;
    }
  }
  //Validation Check for No of Clusters TextBox, enabling Process Button
  OnKeyupClusters_CategoryLevel() {
    if (this.CategoryObj.No_Cluster) {
      if ((/^[0-9]*$/.test(this.CategoryObj.No_Cluster.toString())) == false) {
        bootbox.alert("No of Clusters must be a numeric!");
        this.CategoryObj.No_Cluster = parseInt(this.CategoryObj.No_Cluster.toString().slice(0, -1));
        this.CategoryObj.No_Cluster = this.CategoryObj.No_Cluster || null;
        this.IsProcessEnabled = true;
        return false;
      }
      else if (this.CategoryObj.No_Cluster <= 0) {
        bootbox.alert("No of Clusters must be greater than 0!");
        this.CategoryObj.No_Cluster = parseInt(this.CategoryObj.No_Cluster.toString().slice(0, -1));
        this.CategoryObj.No_Cluster = this.CategoryObj.No_Cluster || null;
        return false;
      }
      else if (this.CategoryObj.No_Cluster.toString().length > 2) {
        bootbox.alert("No of Clusters must not be greater than 99!");
        this.CategoryObj.No_Cluster = parseInt(this.CategoryObj.No_Cluster.toString().slice(0, -1));
        this.CategoryObj.No_Cluster = this.CategoryObj.No_Cluster || null;
        return false;
      }
      this.CheckClassificationCriteriaChangeCatLevel(this.CategoryObj.No_Cluster, this.CategoryObj.selectedIndex_excluded, true, true);
      return true;
    }
    else {
      this.CategoryObj.ReCategorizeEnabled = false;
      return false;
    }
    return true;
  }
  //Validation Check for ExitCondition TextBox, enabling Process Button
  OnKeyupExitCondition_CategoryLevel(isFDS) {
    if (this.CategoryObj.ExitCondition) {
      if (isFDS) {
        if ((/^[0-9]*$/.test(this.CategoryObj.ExitCondition.toString())) == false) {
          bootbox.alert("Allowed maximum % of unclassified tickets must be a numeric!");
          this.CategoryObj.ExitCondition = parseInt(this.CategoryObj.ExitCondition.toString().slice(0, -1));
          this.CategoryObj.ExitCondition = this.CategoryObj.ExitCondition || null;
          return false;
        }
        else if (this.CategoryObj.ExitCondition <= 0) {
          bootbox.alert("Allowed maximum % of unclassified tickets should be greater than 0!");
          this.CategoryObj.ExitCondition = parseInt(this.CategoryObj.ExitCondition.toString().slice(0, -1));
          this.CategoryObj.ExitCondition = this.CategoryObj.ExitCondition || null;
          return false;
        }
        else if (this.CategoryObj.ExitCondition > 100) {
          bootbox.alert("Allowed maximum % of unclassified tickets should not be greater than 100!");
          this.CategoryObj.ExitCondition = parseInt(this.CategoryObj.ExitCondition.toString().slice(0, -1));
          this.CategoryObj.ExitCondition = this.CategoryObj.ExitCondition || null;
          return false;
        }
      }
      else {
        if ((/^[0-9]*$/.test(this.CategoryObj.ExitCondition.toString())) == false) {
          bootbox.alert("Exit Condition must be a numeric!");
          this.CategoryObj.ExitCondition = parseInt(this.CategoryObj.ExitCondition.toString().slice(0, -1));
          this.CategoryObj.ExitCondition = this.CategoryObj.ExitCondition || null;
          return false;
        }
        else if (this.CategoryObj.ExitCondition.toString().length > 6) {
          bootbox.alert("Exit Condition must not be greater than 999999!");
          this.CategoryObj.ExitCondition = parseInt(this.CategoryObj.ExitCondition.toString().slice(0, -1));
          this.CategoryObj.ExitCondition = this.CategoryObj.ExitCondition || null;
          return false;
        }
      }
      this.CheckClassificationCriteriaChangeCatLevel(this.CategoryObj.ExitCondition, this.CategoryObj.selectedIndex_included, true, false);
      return true;
    }
    else {
      this.CategoryObj.ReCategorizeEnabled = false;
      return false;
    }
    return true;
  }

 
  NavigateAutomationPlanner() {
    let automationplannerurl = this.envData.automationplannerurl + `${this.VersionId}/AIAA/${this.userType}/false`;
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = automationplannerurl;
    link.setAttribute('visibility', 'hidden');
    link.click();
    $(link).remove();
  }

  NavigateToHome() {
    switch (this.userType) {
      case 1:
        //that.router.navigate(["proposalsummary"], { queryParamsHandling: "merge" });
        // this.router.navigate(["deepdive"]);
        this.router.navigate(["proposalsummary"]);
        break;
      case 3:
        let e2EUID = this.sessionService.getE2EUId();
        let cMSUID = this.sessionService.getCMSUId();
        let wSUID = this.sessionService.getWSUId();
        this.router.navigate(['deepdive'], { queryParams: { E2EUId: e2EUID, CMSUId: cMSUID, WSUId: wSUID } });
        break;
      case 4:
        this.router.navigate(['deepdive'], { queryParams: { SolutionId: this.sessionService.getSolutionId() } });
        break;
      default:
        break;
    }
  }
  LoadDataForRecategorize(catId) {
    this.isExitChanged_categoryLevel = false;
    this.isClusterChanged_categoryLevel = false;
    this.CategoryObj = new Category();
    let catObject = this.TicketCatagories.find(x => x.CateId == catId);
    this.CategoryObj.CategoryId = catId;
    this.CategoryObj.SubCategoryId = null;
    this.CategoryObj.IsDashboardEnabled = catObject.IsDashboardEnabled;
    this.CategoryObj.CategoryName = catObject.CategoryName;
    this.CategoryObj.includedBtnName = catObject.CategoryName; // Save Old Cat Name
    this.CategoryObj.selectedIndex_included = catObject.ExitCondition ? catObject.ExitCondition : ""; // Save Old Exit condition value
    this.CategoryObj.selectedIndex_excluded = catObject.No_Cluster ? catObject.No_Cluster : ""; // Save Old Cluster value
    this.CategoryObj.ExcludedKeywords = this.getDistinct(catObject.ExcludedKeyWords?.split(',')?.filter(x => x).map(x => x.trim()));
    this.CategoryObj.IncludedKeywords = this.getDistinct(catObject.IncludedKeyWords?.split(',')?.filter(x => x).map(x => x.trim()));
    this.CategoryObj.ExitCondition = catObject.ExitCondition == 0 ? null : catObject.ExitCondition;
    this.CategoryObj.No_Cluster = catObject.No_Cluster == 0 ? null : catObject.No_Cluster;
    this.CategoryObj.ReCategorizeEnabled = false;

    var SelectedLanguageEdit = this.sessionService.getSessionStorageItem('SelectedLanguage');
    var SelectedLanguage = this.sessionService.getSessionStorageItem('SelectedDDLanguage');  
      if(SelectedLanguageEdit!=null && SelectedLanguageEdit!=undefined)
      {        
        if(SelectedLanguageEdit.includes('|'))
        {          
        if(SelectedLanguage=='All' || SelectedLanguage=='null')
        {
          this.DisableEditLanguageAll(false);
        }                
        else if(this.Language_Recat!=null && this.Language_Recat!=undefined && this.Language_Recat!='BsonNull' && this.Language_Recat!='All' && this.Language_Recat!=SelectedLanguage )
        {
          this.DisableEditLanguageAll(false);
        }
        else{
          this.IsProcessEnabled = true;
        }
        }
      }

  }
  KmeansCategoryEdit() {
    if (this.ValidateOpportunityName(this.CategoryObj.CategoryName, this.CategoryObj.includedBtnName, true, 'edit', [],this.envVar.EnableLanguage ?  this.Language : 'English' )) {
      this.spinner.show();
      this.InsertUpdateOpportunityData(this.VersionId, this.CategoryObj.CategoryId, this.CategoryObj.SubCategoryId, 0, 0, this.CategoryObj.CategoryName, this.CategoryObj.IsDashboardEnabled, this.CategoryObj.IncludedKeywords?.join(', '), this.CategoryObj.ExcludedKeywords?.join(', '), '', 'edit', '', '', false, true, null, this.envVar.EnableLanguage ?  this.Language : 'English' );
    }
  }
  CloseRecategorizeModel() {
    this.CategoryObj = new Category();
    this.IsProcessEnabled = false;
  }
  SaveReCategorize() {
    let that = this;
    bootbox.confirm({
      message: 'Are you sure on processing the modified classification criteria?<br /> Click on "Yes" to proceed and you will be redirected to Home page while processing your tickets',
      buttons: {
        confirm: {
          label: 'Yes',
          className: 'btn-primary'
        },
        cancel: {
          label: 'No',
          className: 'btn-secondary'
        }
      },
      callback: function (result) {
        if (result) //'Yes' selection
        {
          that.spinner.show();
          var SelectedLanguage = that.sessionService.getSessionStorageItem('SelectedDDLanguage');
          if(SelectedLanguage==null || SelectedLanguage==undefined || SelectedLanguage=='' || SelectedLanguage=='null')
          {
            SelectedLanguage='All';
          }
          that.iomservice.SaveCategoryClusterEdit(that.CategoryObj.CategoryId, that.CategoryObj.No_Cluster, that.CategoryObj.ExitCondition, that.VersionId, SelectedLanguage).subscribe(data => {
            that.spinner.hide();
            $("#btnRecategorizeModelClose").click();
            if (data["Response"] == "Success") {
              that.messageService.updateDDredirection('reclassified');
              // switch (that.userType) {
              //   case 1:
              //     //that.router.navigate(["proposalsummary"], { queryParamsHandling: "merge" });
              //     that.router.navigate(["deepdive"]);
              //     break;
              //   case 3:
              //     let e2EUID = that.sessionService.getE2EUId();
              //     let cMSUID = that.sessionService.getCMSUId();
              //     let wSUID = that.sessionService.getWSUId();
              //     that.router.navigate(['deepdive'], { queryParams: { E2EUId: e2EUID, CMSUId: cMSUID, WSUId: wSUID } });
              //     break;
              //   case 4:
              //     that.router.navigate(['deepdive'], { queryParams: { SolutionId: that.sessionService.getSolutionId() } });
              //     break;
              //   default:
              //     break;
              // }
            }
            else {
              bootbox.alert("Timeout. Please Refresh and Try again");
            }
          },
            (err: HttpErrorResponse) => {
              that.spinner.hide();
              bootbox.alert("Timeout. Please Refresh and Try again");
            });
        }
        else //'No' selection
        {
          //TODO:
        }
      }
    });
  }
  CheckClassificationCriteriaChange(clvalue, clvalue_old, exvalue, exvalue_old, iscategoryLevel, isCluster) {
    if (clvalue != clvalue_old || exvalue != exvalue_old ) {
      if (!iscategoryLevel) {
        if (!this.IsProcessEnabled) {
          if (this.NoofCluster.toString() != "" && this.ExitCondition.toString() != "") {
            this.IsProcessEnabled = true;
            this.isClusterChanged = true;
            this.isExitChanged = true;
          }
          else {
            this.IsProcessEnabled = false;
            this.isClusterChanged = false;
            this.isExitChanged = false;
          }
        }
        else {
          if (isCluster)
            this.isClusterChanged = true;
          else
            this.isExitChanged = true;
        }
      }
      else {
        if (!this.CategoryObj.ReCategorizeEnabled) {
          if (this.CategoryObj.CategoryName != "" && this.CategoryObj.No_Cluster != null && this.CategoryObj.ExitCondition != null) {
            this.CategoryObj.ReCategorizeEnabled = true;
            this.isClusterChanged_categoryLevel = true;
            this.isExitChanged_categoryLevel = true;
          }
          else {
            this.CategoryObj.ReCategorizeEnabled = false;
            this.isClusterChanged_categoryLevel = false;
            this.isExitChanged_categoryLevel = false;
          }
        }
        else {
          if (isCluster)
            this.isClusterChanged_categoryLevel = true;
          else
            this.isExitChanged_categoryLevel = true;
        }
      }
    }
    else {
      if (!iscategoryLevel) {
        if (this.IsProcessEnabled) {
          if (isCluster) {
            if (!this.isExitChanged) {
              this.IsProcessEnabled = false;
              this.isClusterChanged = false;
            }
            else {
              this.isClusterChanged = false;
            }
          }
          else {
            if (!this.isClusterChanged) {
              this.IsProcessEnabled = false;
              this.isExitChanged = false;
            }
            else {
              this.isExitChanged = false;
            }
          }
          if (!this.isClusterChanged && !this.isExitChanged) {
            this.IsProcessEnabled = false;
          }
        }
      }
      else {
        if (this.CategoryObj.ReCategorizeEnabled) {
          if (isCluster) {
            if (!this.isExitChanged_categoryLevel) {
              this.CategoryObj.ReCategorizeEnabled = false;
              this.isClusterChanged_categoryLevel = false;
            }
            else {
              this.isClusterChanged_categoryLevel = false;
            }
          }
          else {
            if (!this.isClusterChanged_categoryLevel) {
              this.CategoryObj.ReCategorizeEnabled = false;
              this.isExitChanged_categoryLevel = false;
            }
            else {
              this.isExitChanged_categoryLevel = false;
            }
          }
          if (!this.isClusterChanged_categoryLevel && !this.isExitChanged_categoryLevel) {
            this.CategoryObj.ReCategorizeEnabled = false;
          }
        }
      }
    }
  }
  CheckClassificationCriteriaChangeCatLevel(value, value_old, iscategoryLevel, isCluster) {
    if (value != value_old) {
      if (!iscategoryLevel) {
        if (!this.IsProcessEnabled) {
          if (this.NoofCluster.toString() != "" && this.ExitCondition.toString() != "") {
            this.IsProcessEnabled = true;
            this.isClusterChanged = true;
            this.isExitChanged = true;
          }
          else {
            this.IsProcessEnabled = false;
            this.isClusterChanged = false;
            this.isExitChanged = false;
          }
        }
        else {
          if (isCluster)
            this.isClusterChanged = true;
          else
            this.isExitChanged = true;
        }
      }
      else {
        if (!this.CategoryObj.ReCategorizeEnabled) {
          if (this.CategoryObj.CategoryName != "" &&  this.CategoryObj.No_Cluster != null && this.CategoryObj.ExitCondition != null) {
            this.CategoryObj.ReCategorizeEnabled = true;
            this.isClusterChanged_categoryLevel = true;
            this.isExitChanged_categoryLevel = true;
          }
          else {
            this.CategoryObj.ReCategorizeEnabled = false;
            this.isClusterChanged_categoryLevel = false;
            this.isExitChanged_categoryLevel = false;
          }
        }
        else {
          if (isCluster)
            this.isClusterChanged_categoryLevel = true;
          else
            this.isExitChanged_categoryLevel = true;
        }
      }
    }
    else {
      if (!iscategoryLevel) {
        if (this.IsProcessEnabled) {
          if (isCluster) {
            if (!this.isExitChanged) {
              this.IsProcessEnabled = false;
              this.isClusterChanged = false;
            }
            else {
              this.isClusterChanged = false;
            }
          }
          else {
            if (!this.isClusterChanged) {
              this.IsProcessEnabled = false;
              this.isExitChanged = false;
            }
            else {
              this.isExitChanged = false;
            }
          }
          if (!this.isClusterChanged && !this.isExitChanged) {
            this.IsProcessEnabled = false;
          }
        }
      }
      else {
        if (this.CategoryObj.ReCategorizeEnabled) {
          if (isCluster) {
            if (!this.isExitChanged_categoryLevel) {
              this.CategoryObj.ReCategorizeEnabled = false;
              this.isClusterChanged_categoryLevel = false;
            }
            else {
              this.isClusterChanged_categoryLevel = false;
            }
          }
          else {
            if (!this.isClusterChanged_categoryLevel) {
              this.CategoryObj.ReCategorizeEnabled = false;
              this.isExitChanged_categoryLevel = false;
            }
            else {
              this.isExitChanged_categoryLevel = false;
            }
          }
          if (!this.isClusterChanged_categoryLevel && !this.isExitChanged_categoryLevel) {
            this.CategoryObj.ReCategorizeEnabled = false;
          }
        }
      }
    }
  }
  exportDeepdive(VersionId, DeepdiveName): void {
    this.spinner.show();
    this.iomservice.exportDeepdive(VersionId, DeepdiveName).subscribe(data => {
      this.blob = new Blob([data], { type: 'application/excel' });
      var downloadURL = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = DeepdiveName + ".xlsx";
      link.click();
      this.spinner.hide();
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        bootbox.alert("Error occured in export deepdive!");
      });
  }
  expendSubCategory() {
    if (this.iomservice.CategoryIDForRedirection != undefined && this.iomservice.CategoryIDForRedirection != "") {
      setTimeout(() => {
        var catid = this.iomservice.CategoryIDForRedirection;
        $("#catExp_" + catid).click();
        this.iomservice.CategoryIDForRedirection=null;
        this.scrollToElement(document.querySelector("#Category_" + catid));
      }, 2000);
    }
  }
  scrollToElement($element, scrollWindow = true): void {
    var topPos = $element.offsetTop;
    if (scrollWindow) {
      setTimeout(function () { window.scrollTo({ top: topPos + 190, behavior: 'smooth' }); }, 200);
    }
  }
  formatNumber(num)
  {   
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  LemmaCheck(value:boolean){
    this.IsLemmaEnabled = value;
    this.IsLemmaChecked = true;
    this.sessionService.setSessionStorageItem("IsLemmaEnabled", String(value));
    this.sessionService.setSessionStorageItem("IsLemmaChecked", '1');
    this.IsProcessEnabled = true;
  }

  EnableDisableMerge(catId) {
    this.mergedisable = false;   
    let catObject = this.TicketCatagories.find(x => x.CateId == catId);
    let subCatNames = catObject.SubCategoryDetails.map(x => x.SubCategoryName);
    if (subCatNames.length == 1){
      this.mergedisable = true;
    }
    if (subCatNames.length == 2){
      if(catObject.SubCategoryDetails[0].IsSubCategory=="0" || catObject.SubCategoryDetails[1].IsSubCategory=="0")
      {
        this.mergedisable = true;
      }
    }
  }

  DisableEditLanguageAll(IsKmeans) {
    this.isCatOptionsEnabled = true;
    this.isSubcatOptionsEnabled = true;
    this.categoryNameEditOnly = true;
    this.subCategoryNameEditOnly = true;
    this.IsProcessEnabled = false;
    this.EditCluster = true;
    this.EditExitcondition = true;
    if(IsKmeans){
      this.EditCluster = false;
      this.EditExitcondition = false;
    }
    this.disableStopKeywords = true;
    this.disableNewCategory = true;
    this.IsFDSReadonly = false;
    this.disLemma = true;
  }
}
